var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 02:55:52 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2013, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-Regular",
    horizAdvX: 609
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 5 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 521,
    capHeight: 710,
    bbox: "-216 -223 1310 933",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 582,
    d: "M515 680q-32 0 -54 -13t-36 -33t-20.5 -46t-6.5 -51v-16h166v-54h-166v-467h-68v467h-162v-467h-68v467h-72v54h72v6q1 33 11 64.5t29.5 56t49 39t69.5 14.5q35 0 64 -8t48 -18q21 29 53 47t79 18q23 0 40 -4t29.5 -9.5t20.5 -11t14 -8.5l-20 -49q-10 7 -25.5 14.5 t-46.5 7.5zM330 521q0 26 4.5 54t15.5 47q-17 12 -40 16t-40 4q-29 0 -48.5 -10t-31 -26.5t-17 -36.5t-5.5 -41v-7h162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 504,
    d: "M100 467h-72v54h72v14q0 36 10.5 73t33 66t57.5 47.5t83 18.5q27 0 51 -5t43.5 -12t33.5 -15.5t23 -14.5l-31 -49q-17 15 -48 25.5t-68 10.5q-32 0 -54.5 -13t-37 -33t-21.5 -46t-7 -51v-16h261v-521h-68v467h-193v-467h-68v467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 583,
    d: "M585 10q0 -1 -8.5 -3.5t-21.5 -5.5t-30 -5t-34 -2q-48 0 -74.5 28t-26.5 66v483q0 19 -5.5 38.5t-18.5 35t-33.5 25.5t-51.5 10q-30 0 -51 -11.5t-34.5 -31.5t-20 -46.5t-7.5 -56.5v-13h110v-54h-110v-467h-68v467h-72v54h72v19q0 44 11 80.5t33.5 63t56.5 41.5t79 15 q44 0 77.5 -11.5t56 -32.5t33.5 -49.5t11 -62.5v-467q0 -21 13.5 -41.5t41.5 -20.5q19 0 38.5 5.5t20.5 5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 734,
    d: "M100 467h-72v54h72v6q0 31 10 62.5t29.5 56t49.5 40t70 15.5q35 0 64 -8t48 -18q23 29 58 47t85 18q26 0 49.5 -5t43 -12t34.5 -15.5t24 -14.5l-31 -49q-16 14 -47.5 25t-65.5 11q-33 0 -56.5 -13t-38.5 -33t-21.5 -46t-6.5 -51v-16h261v-521h-68v467h-193v-467h-68v467 h-162v-467h-68v467zM330 521q0 26 4.5 54t15.5 47q-17 12 -40 16t-40 4q-29 0 -48.5 -10.5t-31.5 -27t-17 -37t-5 -39.5v-7h162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 817,
    d: "M727 -6q-51 0 -77.5 28t-26.5 66v483q0 19 -5.5 38.5t-18.5 35.5t-33 25.5t-49 9.5q-32 0 -53.5 -12.5t-35.5 -33.5t-20 -48t-6 -56v-9h109v-54h-109v-467h-68v467h-166v-467h-68v467h-72v54h72v6q0 35 11 66.5t32 55.5t52 38t70 14q36 0 61 -8t45 -18q22 31 57.5 48 t86.5 17q43 0 76 -11.5t55.5 -32.5t33.5 -49.5t11 -62.5v-467q0 -21 13.5 -41.5t42.5 -20.5q9 0 19 1.5t18.5 4t14.5 4t7 1.5l13 -56q0 -1 -8.5 -3.5t-22 -5.5t-29.5 -5t-32 -2zM334 521q0 29 3.5 57t11.5 45q-17 12 -36 15.5t-36 3.5q-28 0 -48.5 -10t-34 -26t-20 -36.5 t-6.5 -40.5v-8h166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 255
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 252,
    d: "M92 228v489h68v-489h-68zM92 0v112h68v-112h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 292,
    d: "M69 522v194h59v-194h-59zM164 522v194h59v-194h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 680,
    d: "M642 457h-129l-47 -196h134v-54h-147l-50 -207h-58l51 207h-189l-50 -207h-58l51 207h-113v54h126l47 196h-130v51h143l49 202h58l-50 -202h189l49 202h58l-50 -202h116v-51zM409 261l47 196h-189l-47 -196h189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 619,
    d: "M510 577q-29 32 -76.5 53t-107.5 23v-267q2 0 3.5 -0.5t3.5 -0.5q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80t-18.5 -84t-51.5 -59.5t-78.5 -35.5t-99.5 -13v-97h-37v98q-146 7 -256 102l35 57q35 -38 93.5 -65t130.5 -32v267l-6 2q-56 13 -98 27t-71 35t-43.5 50.5 t-14.5 72.5q0 47 17 83.5t47 62t72.5 40t93.5 17.5v101h37v-100q66 -2 118.5 -23.5t94.5 -58.5zM505 179q0 30 -11.5 51t-34 37t-56 28t-77.5 23v-262q85 0 132 30.5t47 92.5zM136 521q0 -29 9.5 -48.5t29 -34t50 -25t72.5 -20.5v259q-85 -4 -123 -39t-38 -92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 714,
    d: "M190 433q-31 0 -58.5 11t-47.5 30.5t-32 45.5t-12 56t12 56t32 45.5t47.5 31t58.5 11.5t58 -11.5t47.5 -31t32 -45.5t11.5 -56t-11.5 -56t-32 -45.5t-47.5 -30.5t-58 -11zM190 472q20 0 38 8.5t31.5 23t21 33t7.5 39.5q0 22 -8 41t-21.5 33t-31.5 22t-37 8 q-21 0 -39 -8.5t-31.5 -23t-21 -33t-7.5 -39.5t8 -40t21.5 -33.5t31.5 -22.5t38 -8zM525 -10q-31 0 -58 11t-47.5 30.5t-32 46t-11.5 56.5t11.5 56t32 45.5t47.5 30.5t58 11t58.5 -11t47.5 -30.5t32 -45.5t12 -56t-12 -56.5t-32 -46t-47.5 -30.5t-58.5 -11zM525 30 q21 0 38.5 8.5t31 22.5t21 33t7.5 40t-8 40t-21.5 33.5t-31.5 22.5t-37 8q-20 0 -38 -8.5t-31.5 -23t-21 -33t-7.5 -39.5q0 -22 8 -41t21.5 -33t31 -22t37.5 -8zM65 27l279 340l272 347l35 -30l-279 -340l-273 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 667,
    d: "M571 0l-82 86q-42 -45 -96.5 -70.5t-118.5 -25.5q-47 0 -88.5 14t-72 39.5t-48.5 61t-18 78.5q0 36 12 66t33 55.5t48 47.5t57 42q-27 29 -45.5 52t-30 42.5t-16.5 37.5t-5 37q0 33 13.5 61.5t37.5 49.5t56.5 33t70.5 12q35 0 65 -10t52.5 -28.5t35.5 -44.5t13 -57 t-12.5 -56.5t-33.5 -48.5t-49 -44t-60 -42l199 -208q20 38 31.5 82.5t11.5 93.5h58q-1 -62 -16.5 -117t-44.5 -101l133 -138h-90zM281 45q51 0 94 21.5t76 59.5l-215 227q-53 -37 -88 -77.5t-35 -94.5q0 -33 14.5 -58.5t38.5 -43t54 -26t61 -8.5zM163 565q0 -12 3.5 -24 t13.5 -27.5t26.5 -36t43.5 -48.5q58 38 94.5 71.5t36.5 76.5q0 39 -29 64t-74 25q-25 0 -46 -8t-36.5 -22t-24 -32t-8.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 197,
    d: "M69 521v195h59v-195h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 269,
    d: "M44 346q0 51 11 100.5t30 98t44.5 97t54.5 97.5l52 -25q-20 -30 -42.5 -74t-41.5 -94t-31.5 -102.5t-12.5 -100.5q0 -78 34 -170.5t93 -182.5l-51 -27q-63 94 -101.5 190.5t-38.5 192.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 268,
    d: "M224 346q0 -96 -38 -192.5t-102 -190.5l-50 27q29 45 52.5 91t40 91.5t25.5 88.5t9 82q0 48 -12.5 100.5t-31.5 102.5t-41.5 94t-43.5 74l53 25q29 -49 54.5 -97.5t44 -97t29.5 -98t11 -100.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 321,
    d: "M87 546l43 62l-68 22l11 36l69 -26v73h37v-73l69 26l11 -36l-68 -22l44 -62l-32 -22l-42 65l-43 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 415,
    d: "M363 383v-56h-124v-135h-63v135h-124v56h124v135h63v-135h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 225,
    d: "M86 -81l17 84h-23v95h66v-95l-25 -84h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 422,
    d: "M65 241v63h292v-63h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 189,
    d: "M65 0v98h59v-98h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 604,
    d: "M576 710l-472 -710h-77l472 710h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 612,
    d: "M557 293q0 -66 -19 -121.5t-52.5 -96t-79.5 -63t-100 -22.5t-100 22.5t-79.5 63t-52.5 96t-19 121.5t19 121.5t52.5 96t79.5 63.5t100 23t100 -23t79.5 -63.5t52.5 -96t19 -121.5zM488 293q0 54 -13.5 98t-37.5 75.5t-57.5 49t-73.5 17.5q-41 0 -74.5 -17.5t-57.5 -49 t-37.5 -75.5t-13.5 -98t13.5 -98t37.5 -75.5t57.5 -48.5t74.5 -17q40 0 73.5 17t57.5 48.5t37.5 75.5t13.5 98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 428,
    d: "M406 62v-62h-339v62h142v428q-8 -12 -27.5 -26t-43 -26t-48.5 -20t-44 -8v66q23 0 50.5 13t52 30t41.5 32t19 20h70v-509h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 521,
    d: "M44 0q0 34 6 68.5t23.5 68.5t50 65.5t86.5 59.5q29 15 60.5 29.5t58 32.5t43.5 40.5t17 52.5q0 19 -8.5 37.5t-25 33t-41 23.5t-57.5 9t-59 -9.5t-45.5 -22.5t-33.5 -27.5t-21 -23.5l-45 49q6 6 23 22t44.5 32t64.5 28.5t83 12.5t82 -12.5t61 -34.5t38 -50.5t13 -59.5 q0 -41 -18 -71t-44.5 -52t-56.5 -37.5t-54 -26.5q-32 -14 -62.5 -31.5t-54.5 -38.5t-39.5 -47t-15.5 -58h356v-62h-429z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 534,
    d: "M343 236q66 -11 105.5 -60t39.5 -121q0 -45 -16.5 -82.5t-47 -64t-73 -41t-94.5 -14.5q-76 0 -133 30.5t-86 84.5l47 43q21 -44 64 -70t108 -26q75 0 118 36.5t43 104.5q0 69 -45 109t-130 40h-25v58h27q77 0 118 35.5t41 92.5q0 30 -11 53t-30.5 38.5t-46 23.5t-57.5 8 q-57 0 -100.5 -25.5t-65.5 -70.5l-44 42q12 26 34 47.5t50 36.5t62 23.5t70 8.5q46 0 84.5 -13t66.5 -36.5t43.5 -56.5t15.5 -73q0 -30 -9 -57.5t-26 -49t-41.5 -36t-55.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 546,
    d: "M356 -127v178h-333v60l355 460h46v-458h88v-62h-88v-178h-68zM95 113h268v351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 545,
    d: "M277 312q49 0 91 -16.5t73.5 -46.5t49.5 -71.5t18 -91.5q0 -53 -19.5 -96.5t-53 -74t-78.5 -47.5t-96 -17q-38 0 -72.5 9.5t-63.5 27.5t-52.5 43t-38.5 56l45 34q28 -49 76.5 -79t106.5 -30q37 0 69 12.5t56 35.5t37.5 55t13.5 70q0 37 -13 67.5t-36 52.5t-54 34t-67 12 q-47 0 -88.5 -20.5t-67.5 -59.5h-63q1 6 5 27t10 50t13 64.5t14 71.5q17 84 37 187h343v-63h-292l-49 -255q26 28 63.5 43.5t82.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 603,
    d: "M559 234q0 -51 -19.5 -95.5t-53.5 -77.5t-80 -52t-99 -19q-56 0 -103 20.5t-80.5 58.5t-52.5 93.5t-19 124.5q0 108 19 188.5t53.5 134t82.5 79.5t107 26q71 0 127 -35t85 -97l-44 -40q-21 51 -66 81.5t-102 30.5q-44 0 -80 -21t-61.5 -60.5t-40 -97.5t-14.5 -131 q22 59 75.5 94t121.5 35q51 0 95.5 -18.5t77.5 -51t52 -76.5t19 -94zM309 50q38 0 71.5 14.5t59 39.5t40 58.5t14.5 71.5t-15 71.5t-40.5 58.5t-59 39.5t-71.5 14.5t-71.5 -14.5t-59 -39.5t-40 -58.5t-14.5 -71.5t15 -71t40.5 -58.5t59 -40t71.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 535,
    d: "M417 520h-383v63h491l-359 -710h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 593,
    d: "M543 197q0 -47 -20 -84.5t-54 -64.5t-79.5 -41.5t-95.5 -14.5q-53 0 -98 16.5t-77.5 45t-50.5 66.5t-18 81q0 34 12.5 63t32.5 51.5t45.5 39t51.5 25.5q-24 10 -45 24.5t-37 33.5t-25.5 42t-9.5 49q0 44 20 77.5t51.5 56.5t71 35t79.5 12t79.5 -12t71 -34.5t51.5 -56.5 t20 -77q0 -26 -9.5 -49t-26 -42.5t-38 -34t-45.5 -24.5q29 -10 55 -27.5t45.5 -40.5t31 -52t11.5 -63zM474 202q0 36 -16 63.5t-42 46.5t-58 29t-63 10q-33 0 -64 -10.5t-56 -30t-40 -47.5t-15 -62q0 -35 16 -62.5t41.5 -46.5t57 -29t63.5 -10t63.5 10.5t56.5 30t40.5 47 t15.5 61.5zM143 526q0 -29 14 -51.5t36 -38t49.5 -23.5t53.5 -8q27 0 54 8t49.5 24t36.5 39t14 52q0 28 -13 50.5t-34.5 38t-49.5 23.5t-58 8q-29 0 -56.5 -8.5t-48.5 -24t-34 -38.5t-13 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 586,
    d: "M36 327q0 51 19.5 95.5t53.5 77.5t80 52t99 19q56 0 103 -20.5t80.5 -58.5t52.5 -93.5t19 -124.5q0 -108 -19 -188.5t-53.5 -134t-83 -79.5t-106.5 -26q-70 0 -126.5 35t-85.5 97l44 40q21 -51 66.5 -81.5t101.5 -30.5q44 0 80 21t62 60.5t40 97t15 131.5 q-23 -59 -76.5 -94t-121.5 -35q-51 0 -95.5 18.5t-77.5 51t-52 76.5t-19 94zM287 511q-38 0 -71.5 -14.5t-59 -39.5t-40.5 -58.5t-15 -71.5t15 -71.5t40.5 -58.5t59 -39.5t71.5 -14.5t72 14.5t59 39.5t39.5 58.5t14.5 71.5q0 37 -14.5 70.5t-40 59t-59 40t-71.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 188,
    d: "M65 420v98h58v-98h-58zM65 0v98h58v-98h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 205,
    d: "M70 420v98h58v-98h-58zM76 -81l17 84h-23v95h66v-95l-25 -84h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 508,
    d: "M33 276l419 252v-73l-320 -196l320 -195v-75l-419 250v37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 438,
    d: "M68 194v49h302v-49h-302zM68 309v49h302v-49h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 508,
    d: "M474 239l-419 -250v75l320 195l-320 196v73l419 -252v-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 476,
    d: "M154 202q0 66 20.5 105t64.5 65q20 12 44 24.5t45 30.5t35.5 43t14.5 62q0 33 -11.5 57t-30.5 40.5t-43.5 24.5t-50.5 8q-54 0 -96.5 -29.5t-64.5 -72.5l-47 30q14 31 36 55t49.5 40.5t59 25t64.5 8.5q37 0 72 -11.5t62.5 -35.5t44 -60t16.5 -84q0 -40 -11.5 -67.5 t-30.5 -47.5t-43.5 -34.5t-49.5 -28.5q-18 -10 -34 -20.5t-29 -27t-20.5 -40.5t-7.5 -60h-58zM155 0v107h59v-107h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 837,
    d: "M417 603q74 0 140 -27.5t116 -78t79 -120.5t29 -155q0 -14 -1.5 -37.5t-6.5 -49.5t-14.5 -53t-25.5 -49t-40 -35.5t-58 -13.5q-25 0 -40.5 7.5t-24.5 20.5t-13 29.5t-6 34.5q-28 -29 -72 -50t-97 -21q-71 0 -110.5 37.5t-39.5 96.5q0 38 16.5 64t43 41.5t59.5 22t66 6.5 q44 0 77 -8.5t50 -14.5q0 36 -5.5 65.5t-19.5 50.5t-38 33t-61 12q-39 0 -75 -12.5t-65 -34.5l-18 39q36 24 76.5 38t87.5 14q55 0 87.5 -18.5t49.5 -48t21.5 -66t4.5 -72.5v-129q0 -22 1.5 -40.5t7 -31.5t16 -20.5t27.5 -7.5q31 0 51 21.5t32 52.5t16.5 66.5t4.5 62.5 q0 72 -25 135t-69.5 109.5t-104.5 73.5t-130 27q-68 0 -128.5 -25.5t-106 -70.5t-72 -107t-26.5 -136q0 -71 25 -133.5t68.5 -109t103.5 -73t131 -26.5q43 0 79.5 10t73.5 28l13 -32q-41 -20 -83 -30t-84 -10q-75 0 -141 28t-115.5 78.5t-78 119.5t-28.5 150 q0 85 30.5 153.5t82 117.5t118.5 75.5t139 26.5zM478 70q42 20 53.5 47t11.5 55v40q-13 2 -46.5 12t-81.5 10q-26 0 -51 -4.5t-44 -15.5t-30.5 -28.5t-11.5 -44.5q0 -42 30 -67.5t77 -25.5q25 0 49.5 6.5t43.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 666,
    d: "M623 183q0 -40 -16 -73.5t-43 -58t-63 -38t-77 -13.5h-335v710h342q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -54 -27 -98.5t-75 -66.5q61 -18 96.5 -67t35.5 -114zM553 195q0 26 -9 50.5t-25.5 43t-39 30t-48.5 11.5h-272v-269h265q27 0 50.5 11t41 29.5t27.5 43 t10 50.5zM159 649v-262h244q26 0 48.5 11t38.5 29t25 41.5t9 49.5q0 27 -8.5 51t-24 41.5t-36.5 28t-46 10.5h-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 686,
    d: "M42 360q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5t84 -66t105.5 -24.5q30 0 61.5 7.5t61 24t54.5 41 t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-73 0 -134 32t-105 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 715,
    d: "M89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171q66 0 116.5 22.5t84.5 62t51.5 93t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 589,
    d: "M89 0v710h466v-62h-396v-261h334v-58h-334v-329h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 716,
    d: "M602 104q-99 -109 -228 -109q-72 0 -132.5 31t-105 82t-69.5 115.5t-25 132.5q0 71 24.5 136t68.5 114.5t104 79t131 29.5q52 0 95 -11.5t76.5 -32t58 -49t41.5 -62.5l-54 -36q-35 66 -91 97t-127 31q-59 0 -106.5 -25t-81 -66.5t-51.5 -95t-18 -110.5q0 -60 20.5 -114 t56.5 -94.5t84.5 -64.5t105.5 -24q61 0 116.5 28.5t106.5 90.5v118h-158v54h217v-349h-59v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 738,
    d: "M649 710v-710h-69v332h-421v-332h-70v710h70v-316h421v316h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 481,
    d: "M34 89q22 -15 56.5 -26t77.5 -11q54 0 86.5 19.5t49.5 57.5t22 93.5t5 126.5v361h70v-361q0 -81 -7.5 -147.5t-31.5 -113.5t-70 -73t-124 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 643,
    d: "M89 0v709h70v-412l391 413h77l-290 -312l305 -398h-77l-272 357l-134 -139v-218h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 583,
    d: "M89 0v710h70v-648h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 877,
    d: "M718 0v583l-259 -451h-41l-259 451v-583h-70v710h72l277 -486l279 486h71v-710h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 772,
    d: "M159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 751,
    d: "M375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5 q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 622,
    d: "M89 0v710h294q46 0 84.5 -19.5t66.5 -51t44 -71.5t16 -81q0 -44 -15 -84.5t-42 -71.5t-64.5 -50t-83.5 -19h-230v-262h-70zM159 324h227q31 0 56.5 13.5t43.5 36t28 52t10 61.5q0 33 -11.5 62.5t-31 51.5t-46 34.5t-55.5 12.5h-221v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 749,
    d: "M569 63q-41 -32 -89.5 -50t-104.5 -18q-74 0 -135.5 31t-105.5 81t-68 115t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -73 -26.5 -139t-73.5 -116l84 -99h-69zM375 58q45 0 83 14.5t70 39.5l-89 106h69 l57 -68q35 42 54 95.5t19 109.5q0 58 -19.5 111.5t-54.5 94.5t-83 66t-106 25q-60 0 -109 -25.5t-83 -67.5t-52.5 -95.5t-18.5 -108.5q0 -58 19 -111.5t54 -95t83 -66t107 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 653,
    d: "M89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61t-11.5 61.5t-31 51.5t-46 35t-55.5 13h-226v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 607,
    d: "M504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5q-165 0 -285 103l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21 t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 610,
    d: "M593 648h-253v-648h-70v648h-253v62h576v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 679,
    d: "M86 710l254 -623l253 623h73l-296 -710h-61l-296 710h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1046,
    d: "M356 705h66l100 -252l101 252h67l-124 -303l136 -321l257 629h76l-301 -710h-62l-149 351l-150 -351h-61l-300 710h75l258 -629l135 321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 632,
    d: "M84 710l233 -310l233 310h77l-273 -360l265 -350h-77l-225 300l-225 -300h-79l265 350l-273 360h79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 651,
    d: "M93 710l232 -382l234 382h76l-275 -446v-264h-70v266l-274 444h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 629,
    d: "M31 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 258,
    d: "M88 -40v780h119v-57h-55v-666h55v-57h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 568,
    d: "M105 710l435 -710h-76l-436 710h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 258,
    d: "M50 -40v57h56v666h-56v57h120v-780h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 539,
    d: "M43 303l198 407h58l197 -407h-60l-166 343l-169 -343h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 511,
    d: "M65 -62v62h381v-62h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 222,
    d: "M49 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 617,
    d: "M330 -10q-62 0 -113.5 31t-80.5 80v-101h-61v730h68v-318q35 53 84 85.5t114 32.5q55 0 98.5 -23t74 -61.5t47 -87t16.5 -99.5q0 -55 -19 -104t-52 -85.5t-78.5 -58t-97.5 -21.5zM314 50q43 0 78.5 17.5t61 47t40 67t14.5 77.5q0 41 -13.5 79t-38 67.5t-59 47t-75.5 17.5 q-31 0 -58 -10.5t-50 -28.5t-41 -41.5t-30 -49.5v-162q4 -27 21.5 -50.5t42 -40.5t53 -27t54.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 549,
    d: "M39 262q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20 q-11 -28 -32 -51.5t-49.5 -41t-63 -27t-71.5 -9.5q-57 0 -105 21.5t-83 59t-54.5 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 622,
    d: "M289 -10q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t95.5 21.5q66 0 117 -34.5t80 -83.5v318h68v-642q0 -28 24 -28v-60q-15 -3 -24 -3q-24 0 -42 15.5t-18 37.5v51q-31 -51 -84 -81t-110 -30zM304 50q25 0 53.5 10t53.5 27.5 t42.5 41t21.5 50.5v161q-10 27 -29 50.5t-43.5 41.5t-52.5 28t-55 10q-42 0 -76 -18t-58.5 -47.5t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5t61.5 -45.5t76.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 330,
    d: "M100 0v467h-72v54h72v14q0 96 41 150.5t112 54.5q31 0 60 -9t50 -24l-21 -49q-14 11 -34.5 17t-41.5 6q-48 0 -73 -37t-25 -107v-16h144v-54h-144v-467h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 618,
    d: "M284 -7q-54 0 -98.5 22.5t-77 59.5t-50.5 85t-18 99q0 54 17.5 103.5t49.5 86.5t76.5 59t98.5 22q67 0 116 -33.5t84 -84.5v109h61v-523q0 -54 -20.5 -95.5t-55 -69.5t-81 -42t-98.5 -14q-90 0 -145 32t-89 86l42 33q31 -50 82 -73.5t110 -23.5q38 0 72 10.5t59.5 31 t40.5 52t15 73.5v103q-30 -50 -82 -79t-109 -29zM303 50q30 0 59 11t52.5 29.5t39.5 41.5t21 47v161q-11 28 -30 52t-43 41t-51.5 27t-55.5 10q-44 0 -78.5 -18.5t-58.5 -48.5t-36.5 -68t-12.5 -77q0 -42 15 -80t41.5 -66.5t61.5 -45t76 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 583,
    d: "M513 0h-68v291q0 89 -30.5 133t-89.5 44q-29 0 -57.5 -11.5t-53.5 -31.5t-43.5 -47t-27.5 -59v-319h-68v730h68v-327q31 59 86 93t119 34q45 0 76 -16.5t51 -46t29 -71t9 -91.5v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68zM75 630v100h68v-100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 225,
    d: "M-3 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM82 630v100h68v-100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 530,
    d: "M447 0l-192 267l-112 -104v-163h-68v730h68v-496l293 286h77l-213 -213l221 -307h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 272,
    d: "M78 730h68v-612q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5q-47 0 -74 26.5t-27 74.5v635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 919,
    d: "M850 0h-68v291q0 91 -29 134t-86 43q-30 0 -56.5 -11t-49 -31t-39.5 -47.5t-26 -60.5v-318h-68v291q0 93 -28 135t-86 42q-59 0 -105 -41t-66 -108v-319h-68v521h62v-118q32 60 84 93.5t115 33.5q66 0 105.5 -37t48.5 -97q73 134 201 134q44 0 74.5 -16t49 -45.5t27 -71 t8.5 -92.5v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 583,
    d: "M513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 595,
    d: "M297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5 t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 617,
    d: "M341 -10q-66 0 -116.5 33.5t-81.5 84.5v-321h-68v734h61v-101q32 49 83 79.5t111 30.5q54 0 99 -22.5t78 -60t51.5 -86.5t18.5 -101q0 -55 -17 -104t-48.5 -86t-75 -58.5t-95.5 -21.5zM322 50q42 0 76.5 18t59 47.5t37.5 67t13 77.5q0 42 -15 80t-41 67t-61.5 46 t-76.5 17q-26 0 -54.5 -10.5t-53 -28t-42 -41t-21.5 -49.5v-160q12 -28 30.5 -52t42 -41.5t50.5 -27.5t56 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 617,
    d: "M276 -10q-53 0 -96.5 22.5t-74.5 60t-48 86t-17 101.5q0 54 19 103t52.5 86t79 59t97.5 22q30 0 58.5 -8.5t53.5 -23t45.5 -35t35.5 -44.5v102h61v-643q0 -28 25 -29v-59q-10 -2 -19.5 -2h-18.5q-23 2 -39 19.5t-16 41.5v259q-38 -58 -88 -88t-110 -30zM297 50 q30 0 56.5 10t49 26.5t40.5 39t31 47.5v161q-4 27 -21 51.5t-41.5 43.5t-53.5 30t-57 11q-42 0 -77.5 -18t-61 -47.5t-39.5 -67.5t-14 -78q0 -42 14 -80t39 -66.5t59.5 -45.5t75.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 351,
    d: "M335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 487,
    d: "M248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5t62 29.5t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40 q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 335,
    d: "M325 25q-6 -3 -17.5 -8t-26.5 -10t-34 -9t-40 -4q-22 0 -42 6t-35 18.5t-24 31.5t-9 44v373h-72v54h72v176h68v-176h120v-54h-120v-354q2 -29 20.5 -42.5t42.5 -13.5q29 0 51 9.5t28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 533,
    d: "M231 0l-212 521h70l179 -458l180 458h66l-212 -521h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 813,
    d: "M731 521h67l-224 -521h-56l-112 266l-111 -266h-56l-224 521h66l190 -451l99 238l-89 212h57l68 -170l68 170h58l-89 -212l99 -238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 504,
    d: "M88 521l156 -204l8 -15l8 15l156 204h73l-199 -262l199 -259h-73l-156 203l-8 14l-8 -14l-156 -203h-73l199 259l-199 262h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 542,
    d: "M105 -160q8 -1 15.5 -1.5t14.5 -0.5q18 0 28.5 5t20.5 22t22.5 49t35.5 86l-227 521h70l193 -458l179 458h65l-270 -672q-11 -29 -36.5 -50.5t-69.5 -21.5q-10 0 -19 0.5t-22 2.5v60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 492,
    d: "M31 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 259,
    d: "M154 683v-261q0 -12 -5.5 -30t-21.5 -32q16 -14 21.5 -32.5t5.5 -29.5v-272h55v-57h-94q-8 0 -15.5 6.5t-7.5 23.5v281q0 20 -10 36.5t-29 18.5v52q10 0 17.5 6t12.5 14t7 17.5t2 15.5v270q0 19 9 24.5t14 5.5h94v-57h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 231,
    d: "M86 -130v905h59v-905h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 259,
    d: "M50 683v57h94q5 0 14 -5.5t9 -24.5v-270q0 -6 2 -15.5t6.5 -17.5t11.5 -14t18 -6v-52q-19 -2 -28.5 -18.5t-9.5 -36.5v-281q0 -17 -7.5 -23.5t-15.5 -6.5h-94v57h55v272q0 11 5 29.5t21 32.5q-16 14 -21 32t-5 30v261h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 511,
    d: "M66 241q0 5 6 21.5t18.5 34.5t33 32.5t50.5 14.5q23 0 43 -9t39 -20t38 -20t40 -9q19 0 32 7.5t21.5 16.5t12 17.5t3.5 10.5h43q0 -2 -5.5 -17.5t-18.5 -33t-35 -32t-54 -14.5q-25 0 -46 9t-40.5 20t-37.5 20t-36 9t-30 -9t-19.5 -19.5t-11 -19.5t-3.5 -10h-43v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 255
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 251,
    d: "M159 487v-489h-68v489h68zM159 715v-112h-68v112h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 561,
    d: "M276 -120v111q-51 4 -94 28.5t-73.5 61.5t-48 83t-17.5 94q0 51 16.5 97.5t46.5 83.5t73 61t97 29v116h37v-116q75 -2 125 -34.5t78 -88.5l-65 -21q-23 41 -59 61t-79 22v-417q19 1 42 8t43.5 18t36 27t20.5 35l67 -20q-12 -32 -36 -56.5t-53.5 -40.5t-61 -24t-58.5 -8 v-110h-37zM113 258q0 -37 12 -71.5t34 -62t52 -46t65 -24.5v412q-39 -4 -69.5 -23t-51 -48t-31.5 -65t-11 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 499,
    d: "M52 372h94q-11 21 -23 41.5t-22 41.5t-16.5 43t-6.5 46q0 36 14 67t39 54t57.5 36.5t70.5 13.5q54 0 102.5 -28t78.5 -77l-40 -42q-24 42 -62.5 66t-80.5 24q-24 0 -45.5 -9t-37 -25t-24.5 -37.5t-9 -46.5q0 -22 7 -42.5t17 -41t22 -41t23 -43.5h178v-54h-158 q8 -30 8 -60q0 -50 -23 -96.5t-80 -107.5q36 9 73 9q21 0 39 -3t35 -6t33.5 -6t34.5 -3q20 0 41 4.5t48 13.5l17 -52q-26 -13 -54 -19.5t-55 -6.5q-23 0 -43 3.5t-40 8t-40.5 8.5t-43.5 4t-52.5 -4.5t-55.5 -12.5l-18 50q34 34 58 62.5t38.5 53.5t21 48.5t6.5 47.5 q0 17 -2.5 33t-7.5 31h-116v54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 537,
    d: "M156 480q45 39 112 39q33 0 61.5 -10.5t51.5 -28.5l70 71l34 -33l-72 -72q17 -23 26 -51t9 -59q0 -30 -9.5 -58.5t-26.5 -51.5l73 -72l-30 -29l-74 69q-22 -18 -50.5 -28.5t-62.5 -10.5t-62.5 10.5t-51.5 28.5l-71 -69l-30 29l71 71q-36 50 -36 111q0 64 35 111l-70 71 l33 33zM145 335q0 -27 9.5 -51t26.5 -42t39 -28.5t48 -10.5q25 0 47.5 10.5t39.5 28.5t26.5 42.5t9.5 52.5t-9.5 52.5t-26.5 42.5t-39.5 28t-47.5 10q-26 0 -48 -10.5t-39 -28.5t-26.5 -43t-9.5 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 676,
    d: "M432 366h84v-48h-111l-33 -54v-27h145v-48h-145v-189h-70v189h-143v48h143v29l-31 52h-112v48h86l-216 344h76l232 -382l234 382h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 234,
    d: "M147 277v-407h-60v407h60zM147 775v-407h-60v407h60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 506,
    d: "M417 195q23 -14 34.5 -40.5t11.5 -61.5q0 -48 -19 -82.5t-49 -56t-66.5 -32t-70.5 -10.5q-33 0 -62 8.5t-53.5 21.5t-45 29t-35.5 32l45 42q71 -68 148 -68q26 0 50.5 7t44 21.5t31.5 35.5t12 49q0 29 -12.5 46t-31.5 26t-41 12t-41 5q-94 8 -144.5 46.5t-50.5 112.5 q0 30 7.5 52.5t18.5 36.5q-21 15 -36 46t-15 69q0 39 16.5 70.5t44 54.5t64 35.5t77.5 12.5q64 0 108 -28.5t70 -66.5l-54 -25q-8 16 -22 27t-31 18t-35.5 10t-35.5 3q-26 0 -50.5 -7t-43 -21.5t-29.5 -35.5t-11 -49q0 -32 13.5 -50.5t33 -28.5t42.5 -14t43 -5 q35 -3 70.5 -11t64.5 -25t47 -45t18 -72q0 -31 -8.5 -55.5t-21.5 -38.5zM138 329q0 -45 24.5 -64.5t59 -27.5t71 -10.5t60.5 -11.5q14 11 21.5 31t7.5 41q0 29 -12.5 47.5t-32 30t-43 16t-45.5 5.5q-23 1 -43 3t-43 11q-11 -11 -18 -29.5t-7 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 329,
    d: "M61 633v94h58v-94h-58zM210 633v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 832,
    d: "M415 -7q-79 0 -146.5 27.5t-116.5 76t-76.5 114.5t-27.5 144q0 77 27.5 143t76.5 114t116.5 75.5t146.5 27.5t147 -27.5t117 -75.5t77 -114t28 -143q0 -78 -28 -144t-77 -114.5t-117 -76t-147 -27.5zM415 26q70 0 131 24t106 67t71 103t26 133q0 71 -25 131t-70 104 t-106 69t-133 25q-71 0 -132 -25t-105.5 -68.5t-69.5 -104t-25 -130.5t25 -130t69.5 -104t105 -69t132.5 -25zM423 123q-46 0 -88 16.5t-74.5 46.5t-52 73t-19.5 96q0 42 14 84t42 75t71 54t101 21q66 0 117.5 -28.5t74.5 -82.5l-66 -21q-10 22 -25.5 36t-33 22t-35 11 t-32.5 3q-40 0 -69.5 -15.5t-49 -40t-29.5 -56t-10 -62.5q0 -41 15 -73.5t38 -54.5t51.5 -33.5t55.5 -11.5q38 0 76 20.5t55 55.5l66 -19q-7 -18 -24 -38.5t-42 -38t-57 -28.5t-70 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 434,
    d: "M166 346q-25 0 -46.5 8.5t-37.5 23.5t-25 35t-9 43q0 24 11 44t31 34.5t47 22.5t60 8q27 0 54 -4.5t47 -13.5v28q0 43 -25 68t-70 25q-53 0 -114 -41l-20 37q70 46 139 46q70 0 110 -36.5t40 -104.5v-143q0 -21 19 -22v-52q-9 -1 -15 -1.5t-13 -0.5q-18 1 -28.5 11 t-12.5 25l-1 25q-25 -32 -62 -48.5t-79 -16.5zM182 391q32 0 60.5 11.5t43.5 31.5q12 12 12 26v52q-20 9 -44 12.5t-48 3.5q-46 0 -74 -18.5t-28 -49.5q0 -29 22.5 -49t55.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 573,
    d: "M41 276l248 178v-59l-193 -136l193 -134v-59l-248 173v37zM261 276l249 178v-59l-193 -136l193 -134v-59l-249 173v37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 582,
    d: "M512 364v-238h-60v176h-379v62h439z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 570,
    d: "M65 241v63h439v-63h-439z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 832,
    d: "M416 -7q-80 0 -147 27.5t-116.5 76t-77 114.5t-27.5 144q0 77 27.5 143t77 114t116.5 75.5t147 27.5q79 0 146.5 -27.5t116.5 -75.5t77 -114t28 -143q0 -78 -28 -144t-77 -114.5t-116.5 -76t-146.5 -27.5zM416 25q70 0 130.5 24t105.5 67t70.5 103.5t25.5 134.5 q0 70 -25 130t-69.5 104t-105 69t-132.5 25t-133 -25t-105 -69t-69 -103.5t-25 -129.5q0 -71 25 -131t69 -104.5t105 -69.5t133 -25zM263 580h191q29 0 54 -12.5t43 -33t28 -46t10 -51.5q0 -49 -28.5 -87.5t-74.5 -47.5l111 -175h-58l-106 168h-117v-168h-53v453zM454 341 q41 0 62 27.5t21 68.5q0 42 -24.5 68.5t-62.5 26.5h-134v-191h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 396,
    d: "M54 663v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 266,
    d: "M50 642q0 35 24 58.5t59 23.5t59 -23.5t24 -58.5q0 -36 -24 -60t-59 -24t-59 24t-24 60zM102 672q-13 -13 -13 -31t13 -31t31 -13q19 0 32 13q12 14 12 31t-12 31q-12 13 -32 13q-19 0 -31 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 467,
    d: "M72 61v57h323v-57h-323zM395 393v-57h-130v-140h-63v140h-130v57h130v140h63v-140h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 388,
    d: "M36 407q0 39 7.5 67.5t23.5 50t39.5 37.5t55.5 28q23 9 47 17.5t44 19.5t33 27t13 39q0 31 -25.5 52.5t-76.5 21.5q-25 0 -45 -5.5t-36 -14t-27.5 -18t-18.5 -17.5l-30 31q4 5 16 16.5t32.5 23t49 20t65.5 8.5q73 0 109.5 -34t36.5 -85q0 -31 -14.5 -52.5t-35.5 -36.5 t-45.5 -24t-45.5 -16q-33 -11 -55.5 -25t-36 -29t-19.5 -30t-6 -29h253v-43h-308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 390,
    d: "M190 401q-63 0 -105 24t-50 65l27 29q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 54.5t-108.5 19.5h-23v41h23q63 0 99 16.5t36 49.5t-31.5 52.5t-74.5 19.5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17q33 0 61 -8.5 t49 -23t32.5 -34.5t11.5 -44q0 -69 -91 -88q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46.5t-35 -34.5t-51.5 -21.5t-61.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 222,
    d: "M94 620l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 620,
    d: "M82 521h68v-294q0 -177 123 -177q30 0 58.5 10t53 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19 -2h-14q-23 2 -37 18t-14 36v66q-13 -27 -34 -50t-47.5 -40.5t-56.5 -27.5t-61 -10q-48 0 -78.5 23.5t-44.5 61.5v-287h-64v733z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 602,
    d: "M34 469q0 114 74 177.5t208 63.5h241v-54h-70v-736h-60v311h-74v-311h-59v311q-60 1 -108 17.5t-82 47.5t-52 74.5t-18 98.5zM93 471q0 -47 16 -81t43.5 -56.5t64 -34.5t77.5 -14v371q-98 -1 -149.5 -50.5t-51.5 -134.5zM427 656h-74v-371h74v371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 189,
    d: "M65 246v112h59v-112h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 283,
    d: "M39 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l57 105l33 -13l-35 -56q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5q0 -34 -26 -52t-76 -18q-29 0 -54 5.5t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 272,
    d: "M250 451v-45h-201v45h81v309q-5 -6 -16 -14.5t-24.5 -16t-28.5 -13t-27 -5.5v45q16 0 33 8t31 18t23 19t9 10h45v-360h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 449,
    d: "M224 346q-40 0 -73 15t-57 40t-37 58t-13 69q0 37 13 70t37 58t57 39.5t73 14.5t73 -14.5t57 -39.5t37.5 -58t13.5 -70q0 -36 -13 -69t-37 -58t-57.5 -40t-73.5 -15zM101 527q0 -28 9.5 -52t26.5 -42t39 -28t48 -10q25 0 47.5 10.5t39.5 28.5t26.5 42.5t9.5 52.5t-9.5 52 t-26.5 42t-39.5 28t-47.5 10t-47.5 -10.5t-39 -28.5t-26.5 -42.5t-10 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 573,
    d: "M532 239l-248 -173v59l193 134l-193 136v59l248 -178v-37zM312 239l-249 -173v59l193 134l-193 136v59l249 -178v-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 825,
    d: "M687 0v103h-228v42l242 254h31v-252h57v-44h-57v-103h-45zM507 147h181v191zM133 27l279 340l272 347l35 -30l-279 -340l-273 -348zM260 371v-45h-201v45h81v309q-5 -6 -16 -14.5t-24.5 -16t-28.5 -13t-27 -5.5v45q16 0 33 8t31 18t23 19t9 10h45v-360h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 864,
    d: "M516 0q0 39 7.5 67.5t23 50.5t38.5 38t54 28q22 9 45.5 17t43 19.5t32 27t12.5 38.5q0 31 -24.5 53t-74.5 22q-24 0 -44 -5.5t-35 -14t-26.5 -18.5t-18.5 -18l-29 32q4 5 16 16t31.5 22.5t47.5 20t64 8.5q71 0 106.5 -34t35.5 -85q0 -31 -14 -52.5t-34.5 -35.5t-44 -23 t-43.5 -16q-33 -11 -54.5 -25.5t-34 -29.5t-17.5 -30.5t-5 -28.5h248v-44h-306zM99 27l279 340l272 347l35 -30l-279 -340l-273 -348zM261 371v-45h-201v45h81v309q-5 -6 -16 -14.5t-24.5 -16t-28.5 -13t-27 -5.5v45q16 0 33 8t31 18t23 19t9 10h45v-360h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 837,
    d: "M197 321q-63 0 -105 24t-50 65l27 29q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 54.5t-108.5 19.5h-23v41h23q63 0 99 16.5t36 49.5t-31.5 52.5t-74.5 19.5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17q33 0 61 -8.5 t49 -23t32.5 -34.5t11.5 -44q0 -69 -91 -88q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46.5t-35 -34.5t-51.5 -21.5t-61.5 -7.5zM696 0v103h-228v42l242 254h31v-252h57v-44h-57v-103h-45zM516 147h181v191zM166 27l279 340l272 347l35 -30l-279 -340l-273 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 469,
    d: "M318 304q0 -66 -20.5 -105t-64.5 -65q-20 -12 -44 -24.5t-45 -30.5t-35.5 -43t-14.5 -62q0 -33 11.5 -57t30.5 -40.5t43.5 -24.5t50.5 -8q54 0 96.5 29.5t64.5 72.5l47 -30q-14 -31 -36 -55t-49.5 -40.5t-59 -25t-64.5 -8.5q-37 0 -72 11.5t-62.5 35.5t-44 60t-16.5 84 q0 40 11.5 67.5t30.5 47.5t43 34.5t50 28.5q18 10 34 20.5t29 27t20.5 40.5t7.5 60h58zM317 506v-107h-59v107h59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM245 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM345 807l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM215 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM400 825q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5 t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM235 820v94h58v-94h-58zM384 820v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM264 852q0 29 21 47t53 18t53 -18t21 -47q0 -30 -21 -48t-53 -18t-53 18t-21 48zM338 890q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11q16 0 28.5 11t12.5 28t-12 27.5 t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 961,
    d: "M431 710h481v-62h-394v-255h340v-62h-340v-269h403v-62h-471v222h-259l-141 -222h-76zM445 284v342l-222 -342h222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 683,
    d: "M294 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l44 82q-69 4 -127 37t-99.5 84t-64.5 114.5t-23 129.5q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39 t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5t84 -66t105.5 -24.5q30 0 61.5 7.5t61 24t54.5 41t42 59.5l58 -30q-16 -37 -44 -66.5t-63 -50t-74.5 -32.5t-78.5 -15l-28 -46q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5 q0 -34 -26 -52t-76 -18q-29 0 -54 5.5t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM244 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M343 807l-45 17l59 93h72zM566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M214 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M233 820v94h58v-94h-58zM382 820v94h58v-94h-58zM566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM31 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM130 807l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM1 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM20 820v94h58v-94h-58zM169 820v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 721,
    d: "M95 0v330h-61v54h61v326h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM606 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-264h170v-54h-170v-268h171q66 0 116.5 22.5t84.5 62t51.5 93 t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 772,
    d: "M159 580v-580h-70v710h54l470 -591v590h70v-709h-61zM451 825q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16 t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 751,
    d: "M375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5 q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108zM283 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 751,
    d: "M382 807l-45 17l59 93h72zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95 t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 751,
    d: "M253 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355 q0 -58 19 -111.5t54 -95t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 751,
    d: "M375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5 q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108zM438 825q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5 t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 751,
    d: "M273 820v94h58v-94h-58zM422 820v94h58v-94h-58zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355 q0 -58 19 -111.5t54 -95t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 457,
    d: "M394 151l-44 -43l-122 121l-121 -121l-43 44l121 120l-120 121l44 43l119 -120l121 121l43 -44l-120 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 751,
    d: "M650 710l-57 -85q54 -53 84.5 -124.5t30.5 -146.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5q-48 0 -90 13t-78 36l-29 -44h-77l55 83q-54 52 -84 123.5t-30 148.5q0 71 25.5 136t70.5 115t106 79.5t132 29.5q48 0 89.5 -13.5t77.5 -36.5l30 45h77zM112 355 q0 -62 21.5 -118t59.5 -98l314 472q-29 19 -62 29.5t-70 10.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108zM638 355q0 61 -22 116.5t-60 97.5l-314 -472q59 -39 133 -39q60 0 109 26t83 68t52.5 95t18.5 108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25zM285 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 755,
    d: "M385 807l-45 17l59 93h72zM377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 755,
    d: "M255 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66 t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 755,
    d: "M275 820v94h58v-94h-58zM424 820v94h58v-94h-58zM377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 651,
    d: "M93 710l232 -382l234 382h76l-275 -446v-264h-70v266l-274 444h77zM331 807l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 603,
    d: "M364 569q46 0 85 -19.5t67 -51t43.5 -71.5t15.5 -81q0 -44 -14.5 -84.5t-41.5 -71.5t-64.5 -50t-83.5 -19h-212v-121h-70v710h70v-141h205zM368 184q32 0 57.5 13.5t43.5 36t27.5 52t9.5 60.5q0 32 -11.5 61.5t-31 51.5t-46 35t-55.5 13h-203v-323h209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 551,
    d: "M238 57q93 1 149 39t56 115q0 35 -12 64t-34 49.5t-53 32t-68 11.5h-19v62h18q54 0 87.5 31.5t33.5 82.5q0 27 -10 47.5t-26.5 34.5t-39 21t-47.5 7q-33 0 -58 -11.5t-41.5 -32t-25 -47.5t-8.5 -58v-505h-65v515q0 44 15 80.5t41.5 63t63 41t80.5 14.5q40 0 74 -12 t59 -33t39 -50.5t14 -64.5q0 -27 -8.5 -52t-22.5 -45t-33 -34.5t-41 -19.5q75 -16 116 -69.5t41 -126.5q0 -51 -20 -89.5t-56 -65.5t-86.5 -41.5t-112.5 -16.5v63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM170 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM270 620l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM140 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM325 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7 t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM160 633v94h58v-94h-58zM309 633v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM189 665q0 29 21 47t53 18t53 -18t21 -47q0 -30 -21 -48t-53 -18 t-53 18t-21 48zM263 703q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11q16 0 28.5 11t12.5 28t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 932,
    d: "M205 -10q-36 0 -67.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t44.5 50t68.5 32.5t88 11.5q35 0 70 -5.5t64 -14.5q2 19 5.5 39t11.5 37q-10 54 -47 84t-97 30q-39 0 -81 -16t-86 -46l-24 45q103 68 197 68q65 0 111 -27t69 -77q32 47 84 75.5t115 28.5 q57 0 104.5 -21.5t82 -58t54 -86t19.5 -104.5q0 -4 -0.5 -12.5t-0.5 -11.5h-453q3 -42 20 -77.5t44 -61.5t62 -40.5t74 -14.5q25 0 50 7t46 19t37.5 29.5t25.5 38.5l60 -16q-12 -29 -34 -52.5t-51.5 -41t-64 -27t-72.5 -9.5q-69 0 -124.5 31.5t-90.5 83.5q-17 -30 -42.5 -52 t-56.5 -36t-63.5 -20.5t-62.5 -6.5zM221 42q54 0 98.5 20t67.5 53q16 18 18 35q-10 20 -15 46.5t-6 49.5q-60 20 -125 20q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26.5 -36.5t39.5 -24.5t48.5 -9zM837 282q-3 43 -19.5 78.5t-42.5 61.5t-60 40.5t-74 14.5t-74 -14.5 t-60 -40.5t-41.5 -62t-17.5 -78h389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 549,
    d: "M223 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l42 78q-53 4 -97 26.5t-76 59.5t-50 84.5t-18 100.5q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5 q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20q-21 -54 -75 -88.5t-123 -39.5l-26 -42q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5q0 -34 -26 -52t-76 -18q-29 0 -54 5.5 t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM204 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 587,
    d: "M303 620l-45 17l59 93h72zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19 t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 587,
    d: "M174 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5 t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 587,
    d: "M193 633v94h58v-94h-58zM342 633v94h58v-94h-58zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5 q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68zM16 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 218,
    d: "M115 620l-45 17l59 93h72zM75 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 218,
    d: "M-14 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM75 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 218,
    d: "M5 633v94h58v-94h-58zM154 633v94h58v-94h-58zM75 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 602,
    d: "M495 683l-82 -51q43 -42 71 -87.5t44.5 -91t23.5 -90t7 -86.5q0 -65 -21 -117.5t-57 -90.5t-83.5 -58.5t-101.5 -20.5q-52 0 -98.5 19t-81 52t-54.5 77t-20 95q0 49 19.5 93t52.5 77t77.5 52t95.5 19q67 0 121.5 -32.5t81.5 -84.5q-10 63 -38 125t-91 124l-112 -70 l-22 31l106 65q-56 48 -143 98h96q55 -33 100 -72l87 55zM111 232q0 -38 14.5 -71t40 -58t59.5 -39t73 -14q40 0 75 15.5t61 41.5t41 60.5t15 73.5q0 37 -15 69t-40.5 56t-60 37.5t-73.5 13.5t-74 -14.5t-60.5 -39.5t-40.5 -59t-15 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 583,
    d: "M513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305zM358 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16 t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 595,
    d: "M297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5 t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5zM205 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 595,
    d: "M303 620l-45 17l59 93h72zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16 t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 595,
    d: "M174 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66 t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 595,
    d: "M297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5 t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5zM360 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5 t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 595,
    d: "M194 633v94h58v-94h-58zM343 633v94h58v-94h-58zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66 t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 537,
    d: "M239 399v91h59v-91h-59zM239 74v90h59v-90h-59zM67 254v57h403v-57h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 595,
    d: "M93 -1l39 51q-44 38 -68.5 92t-24.5 117q0 55 19.5 104t54 86t81.5 59t103 22q38 0 72 -10t63 -29l23 32h47l-41 -54q45 -38 70 -92.5t25 -117.5q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5q-38 0 -72.5 10t-63.5 28l-22 -29h-46zM297 50q39 0 73.5 16.5t60.5 45 t41 66.5t15 82q0 47 -17.5 87t-46.5 69l-224 -336q44 -30 98 -30zM108 258q0 -48 17 -87.5t46 -68.5l224 337q-45 31 -98 31q-39 0 -73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5zM198 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 594,
    d: "M297 620l-45 17l59 93h72zM238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 594,
    d: "M167 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5 t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 594,
    d: "M187 633v94h58v-94h-58zM336 633v94h58v-94h-58zM238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5 t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 542,
    d: "M105 -160q8 -1 15.5 -1.5t14.5 -0.5q18 0 28.5 5t20.5 22t22.5 49t35.5 86l-227 521h70l193 -458l179 458h65l-270 -672q-11 -29 -36.5 -50.5t-69.5 -21.5q-10 0 -19 0.5t-22 2.5v60zM285 620l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 603,
    d: "M565 257q-1 -54 -21 -103.5t-54.5 -87t-80.5 -60t-100 -22.5q-55 0 -98.5 27t-66.5 63v-287h-69v923h69v-276q29 41 70.5 69.5t103.5 28.5q58 0 103.5 -24.5t77.5 -64t49 -88.5t17 -98zM495 258q0 41 -13 79.5t-36.5 68t-57 47t-73.5 17.5q-30 0 -56 -10t-47.5 -27 t-38.5 -39t-29 -46v-176q0 -24 16 -47t40 -40t53 -27.5t55 -10.5q41 0 75.5 18t59 47t38.5 67t14 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 542,
    d: "M105 -160q8 -1 15.5 -1.5t14.5 -0.5q18 0 28.5 5t20.5 22t22.5 49t35.5 86l-227 521h70l193 -458l179 458h65l-270 -672q-11 -29 -36.5 -50.5t-69.5 -21.5q-10 0 -19 0.5t-22 2.5v60zM175 633v94h58v-94h-58zM324 633v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM194 850v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM119 663v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM338 851q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM263 664q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32 t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 675,
    d: "M614 -175q-37 8 -56 27.5t-19 45.5q0 25 18 50t57 52h-25l-92 222h-319l-91 -222h-75l297 710h59l295 -710q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44zM481 277l-143 351l-145 -351h288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 545,
    d: "M449 -175q-37 8 -56 27.5t-19 45.5q0 25 18 50t57 52q-31 9 -33 46l-2 41q-36 -47 -90.5 -72t-117.5 -25q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45 q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 686,
    d: "M384 807l-45 17l59 93h72zM42 360q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5t84 -66t105.5 -24.5 q30 0 61.5 7.5t61 24t54.5 41t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-73 0 -134 32t-105 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 549,
    d: "M304 620l-45 17l59 93h72zM39 262q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5q25 0 49.5 7t45.5 19.5t36 28.5 t21 34l67 -20q-11 -28 -32 -51.5t-49.5 -41t-63 -27t-71.5 -9.5q-57 0 -105 21.5t-83 59t-54.5 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 686,
    d: "M254 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM42 360q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5 t84 -66t105.5 -24.5q30 0 61.5 7.5t61 24t54.5 41t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-73 0 -134 32t-105 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 549,
    d: "M175 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM39 262q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5 q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20q-11 -28 -32 -51.5t-49.5 -41t-63 -27t-71.5 -9.5q-57 0 -105 21.5t-83 59t-54.5 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 686,
    d: "M42 360q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5t84 -66t105.5 -24.5q30 0 61.5 7.5t61 24t54.5 41 t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-73 0 -134 32t-105 83.5t-68.5 117t-24.5 133.5zM346 820v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 549,
    d: "M39 262q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20 q-11 -28 -32 -51.5t-49.5 -41t-63 -27t-71.5 -9.5q-57 0 -105 21.5t-83 59t-54.5 86.5t-19.5 105zM267 633v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 686,
    d: "M292 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM42 360q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5 t84 -66t105.5 -24.5q30 0 61.5 7.5t61 24t54.5 41t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-73 0 -134 32t-105 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 549,
    d: "M213 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM39 262q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5 q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20q-11 -28 -32 -51.5t-49.5 -41t-63 -27t-71.5 -9.5q-57 0 -105 21.5t-83 59t-54.5 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 715,
    d: "M259 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171q66 0 116.5 22.5 t84.5 62t51.5 93t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 622,
    d: "M624 620l-45 17l59 93h72zM289 -10q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t95.5 21.5q66 0 117 -34.5t80 -83.5v318h68v-642q0 -28 24 -28v-60q-15 -3 -24 -3q-24 0 -42 15.5t-18 37.5v51q-31 -51 -84 -81t-110 -30zM304 50 q25 0 53.5 10t53.5 27.5t42.5 41t21.5 50.5v161q-10 27 -29 50.5t-43.5 41.5t-52.5 28t-55 10q-42 0 -76 -18t-58.5 -47.5t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5t61.5 -45.5t76.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 721,
    d: "M95 0v330h-61v54h61v326h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM606 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-264h170v-54h-170v-268h171q66 0 116.5 22.5t84.5 62t51.5 93 t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 622,
    d: "M289 -10q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t95.5 21.5q66 0 117 -34.5t80 -83.5v205h-114v46h114v67h68v-67h70v-46h-70v-529q0 -28 24 -28v-60q-15 -3 -24 -3q-24 0 -42 15.5t-18 37.5v51q-31 -51 -84 -81t-110 -30z M304 50q25 0 53.5 10t53.5 27.5t42.5 41t21.5 50.5v161q-10 27 -29 50.5t-43.5 41.5t-52.5 28t-55 10q-42 0 -76 -18t-58.5 -47.5t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5t61.5 -45.5t76.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM193 850v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM152 663v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM337 851q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM297 664q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM306 820v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM266 633v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    d: "M566 62v-62q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44l-19 -38q-37 8 -56 27.5t-19 45.5q0 25 18 50t57 52h-428v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 587,
    d: "M291 -181q-37 8 -56 27.5t-19 45.5q0 24 16.5 48.5t53.5 50.5q-54 3 -99.5 25t-78 59t-51 85t-18.5 102q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5 q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-21 -51 -70.5 -85t-113.5 -42q-44 -28 -62 -49t-18 -43q0 -37 52 -44zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    d: "M252 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 587,
    d: "M212 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5 t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 716,
    d: "M246 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM602 104q-99 -109 -228 -109q-72 0 -132.5 31t-105 82t-69.5 115.5t-25 132.5q0 71 24.5 136t68.5 114.5t104 79t131 29.5q52 0 95 -11.5t76.5 -32t58 -49t41.5 -62.5l-54 -36q-35 66 -91 97t-127 31q-59 0 -106.5 -25 t-81 -66.5t-51.5 -95t-18 -110.5q0 -60 20.5 -114t56.5 -94.5t84.5 -64.5t105.5 -24q61 0 116.5 28.5t106.5 90.5v118h-158v54h217v-349h-59v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 617,
    d: "M202 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM283 -7q-54 0 -98.5 22.5t-77 59.5t-50.5 85t-18 99q0 54 17.5 103.5t49.5 86.5t76.5 59t98.5 22q67 0 116 -33.5t84 -84.5v109h61v-523q0 -54 -20.5 -95.5t-55 -69.5t-81 -42t-98.5 -14q-90 0 -145 32t-89 86l42 33 q31 -50 82 -73.5t110 -23.5q38 0 72 10.5t59.5 31t40.5 52t15 73.5v103q-30 -50 -82 -79t-109 -29zM302 50q30 0 59 11t52.5 29.5t39.5 41.5t21 47v161q-11 28 -30 52t-43 41t-51.5 27t-55.5 10q-44 0 -78.5 -18.5t-58.5 -48.5t-36.5 -68t-12.5 -77q0 -42 15 -80t41.5 -66.5 t61.5 -45t76 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 716,
    d: "M602 104q-99 -109 -228 -109q-72 0 -132.5 31t-105 82t-69.5 115.5t-25 132.5q0 71 24.5 136t68.5 114.5t104 79t131 29.5q52 0 95 -11.5t76.5 -32t58 -49t41.5 -62.5l-54 -36q-35 66 -91 97t-127 31q-59 0 -106.5 -25t-81 -66.5t-51.5 -95t-18 -110.5q0 -60 20.5 -114 t56.5 -94.5t84.5 -64.5t105.5 -24q61 0 116.5 28.5t106.5 90.5v118h-158v54h217v-349h-59v104zM369 851q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 617,
    d: "M283 -7q-54 0 -98.5 22.5t-77 59.5t-50.5 85t-18 99q0 54 17.5 103.5t49.5 86.5t76.5 59t98.5 22q67 0 116 -33.5t84 -84.5v109h61v-523q0 -54 -20.5 -95.5t-55 -69.5t-81 -42t-98.5 -14q-90 0 -145 32t-89 86l42 33q31 -50 82 -73.5t110 -23.5q38 0 72 10.5t59.5 31 t40.5 52t15 73.5v103q-30 -50 -82 -79t-109 -29zM302 50q30 0 59 11t52.5 29.5t39.5 41.5t21 47v161q-11 28 -30 52t-43 41t-51.5 27t-55.5 10q-44 0 -78.5 -18.5t-58.5 -48.5t-36.5 -68t-12.5 -77q0 -42 15 -80t41.5 -66.5t61.5 -45t76 -16.5zM325 664q21 0 37.5 19 t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 716,
    d: "M602 104q-99 -109 -228 -109q-72 0 -132.5 31t-105 82t-69.5 115.5t-25 132.5q0 71 24.5 136t68.5 114.5t104 79t131 29.5q52 0 95 -11.5t76.5 -32t58 -49t41.5 -62.5l-54 -36q-35 66 -91 97t-127 31q-59 0 -106.5 -25t-81 -66.5t-51.5 -95t-18 -110.5q0 -60 20.5 -114 t56.5 -94.5t84.5 -64.5t105.5 -24q61 0 116.5 28.5t106.5 90.5v118h-158v54h217v-349h-59v104zM338 820v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 617,
    d: "M283 -7q-54 0 -98.5 22.5t-77 59.5t-50.5 85t-18 99q0 54 17.5 103.5t49.5 86.5t76.5 59t98.5 22q67 0 116 -33.5t84 -84.5v109h61v-523q0 -54 -20.5 -95.5t-55 -69.5t-81 -42t-98.5 -14q-90 0 -145 32t-89 86l42 33q31 -50 82 -73.5t110 -23.5q38 0 72 10.5t59.5 31 t40.5 52t15 73.5v103q-30 -50 -82 -79t-109 -29zM302 50q30 0 59 11t52.5 29.5t39.5 41.5t21 47v161q-11 28 -30 52t-43 41t-51.5 27t-55.5 10q-44 0 -78.5 -18.5t-58.5 -48.5t-36.5 -68t-12.5 -77q0 -42 15 -80t41.5 -66.5t61.5 -45t76 -16.5zM294 633v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 716,
    d: "M345 -199l17 74h-20v76h63v-76l-25 -74h-35zM602 104q-99 -109 -228 -109q-72 0 -132.5 31t-105 82t-69.5 115.5t-25 132.5q0 71 24.5 136t68.5 114.5t104 79t131 29.5q52 0 95 -11.5t76.5 -32t58 -49t41.5 -62.5l-54 -36q-35 66 -91 97t-127 31q-59 0 -106.5 -25 t-81 -66.5t-51.5 -95t-18 -110.5q0 -60 20.5 -114t56.5 -94.5t84.5 -64.5t105.5 -24q61 0 116.5 28.5t106.5 90.5v118h-158v54h217v-349h-59v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 617,
    d: "M334 740l-17 -74h20v-76h-63v76l25 74h35zM283 -7q-54 0 -98.5 22.5t-77 59.5t-50.5 85t-18 99q0 54 17.5 103.5t49.5 86.5t76.5 59t98.5 22q67 0 116 -33.5t84 -84.5v109h61v-523q0 -54 -20.5 -95.5t-55 -69.5t-81 -42t-98.5 -14q-90 0 -145 32t-89 86l42 33 q31 -50 82 -73.5t110 -23.5q38 0 72 10.5t59.5 31t40.5 52t15 73.5v103q-30 -50 -82 -79t-109 -29zM302 50q30 0 59 11t52.5 29.5t39.5 41.5t21 47v161q-11 28 -30 52t-43 41t-51.5 27t-55.5 10q-44 0 -78.5 -18.5t-58.5 -48.5t-36.5 -68t-12.5 -77q0 -42 15 -80t41.5 -66.5 t61.5 -45t76 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 738,
    d: "M248 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM649 710v-710h-69v332h-421v-332h-70v710h70v-316h421v316h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 583,
    d: "M220 644l93 84h47l94 -84l-37 -21l-80 63l-81 -63zM513 0h-68v291q0 89 -30.5 133t-89.5 44q-29 0 -57.5 -11.5t-53.5 -31.5t-43.5 -47t-27.5 -59v-319h-68v730h68v-327q31 59 86 93t119 34q45 0 76 -16.5t51 -46t29 -71t9 -91.5v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 748,
    d: "M654 710v-121h50v-39h-50v-550h-69v332h-421v-332h-70v550h-50v39h50v121h70v-121h421v121h69zM585 394v156h-421v-156h421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 583,
    d: "M513 0h-68v291q0 89 -30.5 133t-89.5 44q-29 0 -57.5 -11.5t-53.5 -31.5t-43.5 -47t-27.5 -59v-319h-68v617h-61v46h61v67h68v-67h123v-46h-123v-214q31 59 86 93t119 34q45 0 76 -16.5t51 -46t29 -71t9 -91.5v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM186 825q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20 t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68zM171 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20 t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM-20 850v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68zM-35 663v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM124 851q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68zM109 664q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 248,
    d: "M110 -175q-37 8 -56 27.5t-19 45.5q0 25 18 50t57 52h-21v710h70v-710q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44l-19 -38v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 218,
    d: "M94 -175q-37 8 -56 27.5t-19 45.5q0 25 18 50t57 52h-19v521h68v-521q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44zM75 630v100h68v-100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM93 820v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 729,
    d: "M89 0v710h70v-710h-70zM282 89q22 -15 56.5 -26t77.5 -11q54 0 86.5 19.5t49.5 57.5t22 93.5t5 126.5v361h70v-361q0 -81 -7.5 -147.5t-31.5 -113.5t-70 -73t-124 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 443,
    d: "M75 0v521h68v-521h-68zM75 630v100h68v-100h-68zM215 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM300 630v100h68v-100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 481,
    d: "M244 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM34 89q22 -15 56.5 -26t77.5 -11q54 0 86.5 19.5t49.5 57.5t22 93.5t5 126.5v361h70v-361q0 -81 -7.5 -147.5t-31.5 -113.5t-70 -73t-124 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 218,
    d: "M-11 -181q-33 0 -62 9t-52 30l34 46q15 -14 34.5 -19t38.5 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-57.5 -11.5zM-14 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 643,
    d: "M299 -199l17 74h-20v76h63v-76l-25 -74h-35zM89 0v709h70v-412l391 413h77l-290 -312l305 -398h-77l-272 357l-134 -139v-218h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 530,
    d: "M244 -199l17 74h-20v76h63v-76l-25 -74h-35zM447 0l-192 267l-112 -104v-163h-68v730h68v-496l293 286h77l-213 -213l221 -307h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 530,
    d: "M447 0l-192 267l-112 -104v-163h-68v521h68v-287l293 286h77l-213 -213l221 -307h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 583,
    d: "M349 807l-45 17l59 93h72zM89 0v710h70v-648h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 272,
    d: "M111 773l-45 17l59 93h72zM78 730h68v-612q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5q-47 0 -74 26.5t-27 74.5v635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 583,
    d: "M302 -199l17 74h-20v76h63v-76l-25 -74h-35zM89 0v710h70v-648h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 272,
    d: "M143 -199l17 74h-20v76h63v-76l-25 -74h-35zM78 730h68v-612q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5q-47 0 -74 26.5t-27 74.5v635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 583,
    d: "M380 620l-45 17l59 93h72zM89 0v710h70v-648h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 272,
    d: "M237 620l-45 17l59 93h72zM78 730h68v-612q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5q-47 0 -74 26.5t-27 74.5v635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 583,
    d: "M89 0v710h70v-648h410v-62h-480zM366 348v112h59v-112h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 314,
    d: "M78 730h68v-612q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5q-47 0 -74 26.5t-27 74.5v635zM239 263v112h59v-112h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 590,
    d: "M96 0v277l-58 -48l-22 40l80 66v375h70v-317l155 129l22 -39l-177 -148v-273h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 292,
    d: "M97 339l-64 -50l-23 39l87 69v333h68v-280l89 71l24 -39l-113 -89v-275q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5q-47 0 -74 26.5t-27 74.5v244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 772,
    d: "M395 807l-45 17l59 93h72zM159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 583,
    d: "M302 620l-45 17l59 93h72zM513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 772,
    d: "M358 -199l17 74h-20v76h63v-76l-25 -74h-35zM159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 583,
    d: "M258 -199l17 74h-20v76h63v-76l-25 -74h-35zM513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 772,
    d: "M304 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 583,
    d: "M211 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 583,
    d: "M42 620l-45 17l38 59v34h94zM513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 766,
    d: "M159 579v-579h-70v710h53l466 -588v587h69v-734q0 -35 -13 -63.5t-35 -49t-49.5 -32t-56.5 -11.5q-32 0 -61.5 9t-52.5 30l34 46q15 -14 34 -19t38 -5q18 0 34.5 7t30 19.5t21.5 29.5t8 37v36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 583,
    d: "M360 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v318q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-328 q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 751,
    d: "M232 850v47h289v-47h-289zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95 t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 595,
    d: "M153 663v47h289v-47h-289zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16 t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 751,
    d: "M375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5 q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108zM376 851q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 595,
    d: "M297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5 t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5zM297 664q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 751,
    d: "M313 807l-37 17l57 93h64zM439 807l-38 17l57 93h64zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5z M112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 595,
    d: "M234 620l-37 17l57 93h64zM360 620l-38 17l57 93h64zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5 t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1153,
    d: "M1112 62v-62h-472v180q-17 -39 -43.5 -73t-60.5 -59t-74.5 -39t-85.5 -14q-74 0 -135.5 30.5t-105.5 81t-68.5 115.5t-24.5 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q46 0 87 -14.5t75 -39.5t59.5 -59t42.5 -72v180h463v-62h-393v-255h339v-62h-339v-269h402z M375 58q60 0 109 25.5t83 67.5t52.5 95.5t18.5 109.5q0 57 -19.5 110.5t-54.5 95t-83 66t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95.5t-18.5 -108.5q0 -58 19 -111.5t54 -95t83 -66t107 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1034,
    d: "M296 -10q-54 0 -101 21t-81.5 57t-54.5 85t-20 105q0 57 20 107t55 86.5t82 57.5t102 21q76 0 135.5 -44.5t86.5 -120.5q28 78 87 121.5t139 43.5q57 0 104.5 -21t81.5 -60t53 -93t19 -120h-446q3 -41 20 -76.5t44 -61.5t62 -41t74 -15q27 0 52.5 7t47 19t37.5 29.5 t24 38.5l58 -16q-13 -29 -35.5 -53t-52 -41t-64 -26.5t-70.5 -9.5q-38 0 -72.5 11.5t-65 33t-55 51.5t-40.5 67q-33 -76 -92 -119.5t-134 -43.5zM297 50q40 0 74.5 16t60 44.5t40.5 66.5t15 82t-15 82.5t-40.5 67t-60 45t-73.5 16.5t-74 -16.5t-60.5 -45.5t-40.5 -68 t-15 -83t15 -82t40.5 -65.5t60 -43.5t73.5 -16zM938 282q-3 43 -19 78.5t-42 61.5t-60 40.5t-72 14.5q-39 0 -72 -14.5t-58 -40.5t-40.5 -62t-17.5 -78h381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 653,
    d: "M324 809l-45 17l59 93h72zM89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61t-11.5 61.5t-31 51.5t-46 35t-55.5 13 h-226v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 351,
    d: "M207 620l-45 17l59 93h72zM335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 653,
    d: "M296 -199l17 74h-20v76h63v-76l-25 -74h-35zM89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61t-11.5 61.5 t-31 51.5t-46 35t-55.5 13h-226v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 351,
    d: "M76 -199l17 74h-20v76h63v-76l-25 -74h-35zM335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 653,
    d: "M232 919l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61t-11.5 61.5 t-31 51.5t-46 35t-55.5 13h-226v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 351,
    d: "M116 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 607,
    d: "M320 823l-45 17l59 93h72zM504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5q-165 0 -285 103l35 57 q19 -20 45.5 -38t59 -31.5t69.5 -21t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 487,
    d: "M252 620l-45 17l59 93h72zM248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5t62 29.5t75.5 10 q60 0 109 -19.5t79 -51.5l-33 -40q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 607,
    d: "M191 848l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5 q-165 0 -285 103l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 487,
    d: "M123 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5 t62 29.5t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 608,
    d: "M244 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l44 81q-157 5 -271 103l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35 t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5l-34 -56q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -47 -17 -81.5 t-47.5 -58t-73 -36.5t-93.5 -15l-28 -46q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5q0 -34 -26 -52t-76 -18q-29 0 -54 5.5t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 488,
    d: "M171 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l42 78q-57 3 -109 22.5t-90 54.5l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25 t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5t62 29.5t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56 q0 -68 -49.5 -109t-134.5 -46l-26 -42q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5q0 -34 -26 -52t-76 -18q-29 0 -54 5.5t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 607,
    d: "M229 933l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5 q-165 0 -285 103l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 487,
    d: "M161 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5 t62 29.5t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    d: "M227 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l47 87h-20v648h-253v62h576v-62h-253v-648h-10l-32 -51q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5q0 -34 -26 -52t-76 -18q-29 0 -54 5.5t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 335,
    d: "M129 -126q14 -7 38 -12.5t50 -5.5q57 0 57 35q0 20 -13.5 28t-36.5 8q-21 0 -44 -4.5t-36 -9.5l44 82q-38 5 -64.5 29.5t-26.5 69.5v373h-72v54h72v176h68v-176h120v-54h-120v-354q2 -29 20.5 -42.5t42.5 -13.5q29 0 51 9.5t28 13.5l18 -55q-11 -5 -36.5 -15.5 t-60.5 -14.5l-29 -46q9 4 19.5 5t18.5 1q35 0 55.5 -15.5t20.5 -45.5q0 -34 -26 -52t-76 -18q-29 0 -54 5.5t-45 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 610,
    d: "M222 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM593 648h-253v-648h-70v648h-253v62h576v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 335,
    d: "M276 620l-45 17l59 93h72zM325 25q-6 -3 -17.5 -8t-26.5 -10t-34 -9t-40 -4q-22 0 -42 6t-35 18.5t-24 31.5t-9 44v373h-72v54h72v176h68v-176h120v-54h-120v-354q2 -29 20.5 -42.5t42.5 -13.5q29 0 51 9.5t28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 641,
    d: "M609 648h-253v-243h220v-39h-220v-366h-70v366h-220v39h220v243h-253v62h576v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 337,
    d: "M326 25q-6 -3 -17.5 -8t-26.5 -10t-34 -9t-40 -4q-22 0 -42 6t-35 18.5t-24 31.5t-9 44v213h-72v46h72v114h-72v54h72v176h68v-176h120v-54h-120v-114h120v-46h-120v-194q2 -29 20.5 -42.5t42.5 -13.5q29 0 51 9.5t28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25zM440 825q-23 0 -39.5 6t-31 13.5t-28 14 t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5zM353 638q-23 0 -39.5 6t-31 13.5t-28 14 t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25zM234 850v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5zM147 663v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25zM378 851q21 0 37.5 19t19.5 47h41 q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5zM291 664q21 0 37.5 19t19.5 47h41 q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 755,
    d: "M304 852q0 29 21 47t53 18t53 -18t21 -47q0 -30 -21 -48t-53 -18t-53 18t-21 48zM378 890q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11q16 0 28.5 11t12.5 28t-12 27.5t-29 10.5zM377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5 t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 594,
    d: "M217 665q0 29 21 47t53 18t53 -18t21 -47q0 -30 -21 -48t-53 -18t-53 18t-21 48zM291 703q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11q16 0 28.5 11t12.5 28t-12 27.5t-29 10.5zM238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10 t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25zM314 807l-37 17l57 93h64zM440 807l-38 17l57 93 h64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5zM227 620l-37 17l57 93h64zM353 620l-38 17 l57 93h64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 756,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -70 -15 -133t-48.5 -111.5t-87 -78.5t-129.5 -33q-44 -28 -62 -49t-18 -43q0 -37 52 -44l-19 -38q-37 8 -56 27.5t-19 45.5q0 25 18 50t56 52q-76 5 -127.5 37t-83 81t-45.5 110.5t-14 126.5v358h69v-358 q0 -56 11 -109t37.5 -94t70.5 -66t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44l-19 -38q-37 8 -56 27.5t-19 45.5q0 25 18 50.5t58 52.5q-17 5 -26.5 20t-9.5 37 v60q-34 -61 -92.5 -94.5t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1046,
    d: "M399 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM356 705h66l100 -252l101 252h67l-124 -303l136 -321l257 629h76l-301 -710h-62l-149 351l-150 -351h-61l-300 710h75l258 -629l135 321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 813,
    d: "M283 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63zM731 521h67l-224 -521h-56l-112 266l-111 -266h-56l-224 521h66l190 -451l99 238l-89 212h57l68 -170l68 170h58l-89 -212l99 -238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 651,
    d: "M93 710l232 -382l234 382h76l-275 -446v-264h-70v266l-274 444h77zM202 832l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 542,
    d: "M105 -160q8 -1 15.5 -1.5t14.5 -0.5q18 0 28.5 5t20.5 22t22.5 49t35.5 86l-227 521h70l193 -458l179 458h65l-270 -672q-11 -29 -36.5 -50.5t-69.5 -21.5q-10 0 -19 0.5t-22 2.5v60zM155 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 651,
    d: "M93 710l232 -382l234 382h76l-275 -446v-264h-70v266l-274 444h77zM221 820v94h58v-94h-58zM370 820v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 629,
    d: "M337 807l-45 17l59 93h72zM31 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 492,
    d: "M262 620l-45 17l59 93h72zM31 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 629,
    d: "M31 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55zM300 820v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 492,
    d: "M31 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46zM224 633v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 629,
    d: "M246 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM31 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 492,
    d: "M170 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM31 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 737,
    d: "M365 -6q-70 0 -131.5 28t-107 76t-71.5 113t-26 139v19t2 14h587q-5 57 -27.5 106t-57 85t-79.5 56t-96 20q-36 0 -70 -10t-62.5 -28.5t-50 -44t-32.5 -56.5l-66 30q18 38 48 70t68 55t82 36t90 13q68 0 128 -28.5t105 -78t71 -115.5t26 -142q0 -75 -25.5 -140 t-70.5 -113.5t-105 -76t-129 -27.5zM365 57q51 0 96 20t79.5 55.5t55.5 84t24 105.5h-516q3 -57 25 -105.5t57 -84t81 -55.5t98 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 526,
    d: "M144 -181q-32 0 -61.5 9t-52.5 30l34 46q15 -14 34.5 -19t38.5 -5q17 0 34 7t30 19.5t21 29.5t8 37v433h-73v54h73v75q0 96 40.5 150.5t112.5 54.5q29 0 58.5 -9t50.5 -24l-20 -49q-14 11 -35 17t-42 6q-48 0 -72.5 -37t-24.5 -107v-77h143v-54h-143v-431 q0 -35 -13 -63.5t-34.5 -49t-49.5 -32t-57 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1343,
    d: "M960 917l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM746 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55zM89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5 t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171q66 0 116.5 22.5t84.5 62t51.5 93t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1206,
    d: "M885 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM746 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46zM89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5 t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171q66 0 116.5 22.5t84.5 62t51.5 93t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1113,
    d: "M792 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86zM653 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46zM289 -10q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t95.5 21.5q66 0 117 -34.5t80 -83.5v318h68v-642 q0 -28 24 -28v-60q-15 -3 -24 -3q-24 0 -42 15.5t-18 37.5v51q-31 -51 -84 -81t-110 -30zM304 50q25 0 53.5 10t53.5 27.5t42.5 41t21.5 50.5v161q-10 27 -29 50.5t-43.5 41.5t-52.5 28t-55 10q-42 0 -76 -18t-58.5 -47.5t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5 t61.5 -45.5t76.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1064,
    d: "M617 89q22 -15 56.5 -26t77.5 -11q54 0 86.5 19.5t49.5 57.5t22 93.5t5 126.5v361h70v-361q0 -81 -7.5 -147.5t-31.5 -113.5t-70 -73t-124 -26q-90 0 -154 44zM89 0v710h70v-648h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 807,
    d: "M580 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM665 630v100h68v-100h-68zM89 0v710h70v-648h410v-62h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 497,
    d: "M269 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM354 630v100h68v-100h-68zM78 730h68v-612q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13 t-47.5 -5q-47 0 -74 26.5t-27 74.5v635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1253,
    d: "M806 89q22 -15 56.5 -26t77.5 -11q54 0 86.5 19.5t49.5 57.5t22 93.5t5 126.5v361h70v-361q0 -81 -7.5 -147.5t-31.5 -113.5t-70 -73t-124 -26q-90 0 -154 44zM159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 997,
    d: "M769 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM854 630v100h68v-100h-68zM159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 808,
    d: "M580 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM665 630v100h68v-100h-68zM513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5 t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 751,
    d: "M348 -178q-37 8 -56 27.5t-19 45.5q0 25 18 50t56 52q-69 6 -125 38t-96 81.5t-62 111.5t-22 127q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -68 -23.5 -131t-65.5 -112t-99.5 -80t-124.5 -35q-44 -27 -62 -48.5 t-18 -43.5q0 -37 52 -44zM112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 595,
    d: "M288 -181q-37 8 -56 27.5t-19 45.5q0 24 16.5 48.5t53.5 50.5q-54 3 -99 25t-77 58.5t-50 84t-18 100.5q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -50 -16.5 -95t-45.5 -81t-69.5 -59.5t-89.5 -30.5q-44 -28 -62 -49t-18 -43 q0 -37 52 -44zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1329,
    d: "M731 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55zM89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171 q66 0 116.5 22.5t84.5 62t51.5 93t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1206,
    d: "M746 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46zM89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171 q66 0 116.5 22.5t84.5 62t51.5 93t17.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1113,
    d: "M653 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46zM289 -10q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t95.5 21.5q66 0 117 -34.5t80 -83.5v318h68v-642q0 -28 24 -28v-60q-15 -3 -24 -3q-24 0 -42 15.5t-18 37.5v51 q-31 -51 -84 -81t-110 -30zM304 50q25 0 53.5 10t53.5 27.5t42.5 41t21.5 50.5v161q-10 27 -29 50.5t-43.5 41.5t-52.5 28t-55 10q-42 0 -76 -18t-58.5 -47.5t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5t61.5 -45.5t76.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 716,
    d: "M379 807l-45 17l59 93h72zM602 104q-99 -109 -228 -109q-72 0 -132.5 31t-105 82t-69.5 115.5t-25 132.5q0 71 24.5 136t68.5 114.5t104 79t131 29.5q52 0 95 -11.5t76.5 -32t58 -49t41.5 -62.5l-54 -36q-35 66 -91 97t-127 31q-59 0 -106.5 -25t-81 -66.5t-51.5 -95 t-18 -110.5q0 -60 20.5 -114t56.5 -94.5t84.5 -64.5t105.5 -24q61 0 116.5 28.5t106.5 90.5v118h-158v54h217v-349h-59v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 617,
    d: "M311 620l-45 17l59 93h72zM283 -7q-54 0 -98.5 22.5t-77 59.5t-50.5 85t-18 99q0 54 17.5 103.5t49.5 86.5t76.5 59t98.5 22q67 0 116 -33.5t84 -84.5v109h61v-523q0 -54 -20.5 -95.5t-55 -69.5t-81 -42t-98.5 -14q-90 0 -145 32t-89 86l42 33q31 -50 82 -73.5t110 -23.5 q38 0 72 10.5t59.5 31t40.5 52t15 73.5v103q-30 -50 -82 -79t-109 -29zM302 50q30 0 59 11t52.5 29.5t39.5 41.5t21 47v161q-11 28 -30 52t-43 41t-51.5 27t-55.5 10q-44 0 -78.5 -18.5t-58.5 -48.5t-36.5 -68t-12.5 -77q0 -42 15 -80t41.5 -66.5t61.5 -45t76 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 676,
    d: "M368 809q20 -7 32 -22.5t12 -37.5q0 -20 -9.5 -35t-26.5 -23l287 -691h-74l-92 222h-319l-91 -222h-75l289 690q-17 8 -27 23.5t-10 35.5q0 27 18 44.5t47 19.5l34 105h72zM481 277l-143 351l-145 -351h288zM338 787q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11 q16 0 28.5 11t12.5 28t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM270 770l-45 17l59 93h72zM189 665q0 29 21 47t53 18t53 -18t21 -47 q0 -30 -21 -48t-53 -18t-53 18t-21 48zM263 703q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11q16 0 28.5 11t12.5 28t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 961,
    d: "M518 807l-45 17l59 93h72zM431 710h481v-62h-394v-255h340v-62h-340v-269h403v-62h-471v222h-259l-141 -222h-76zM445 284v342l-222 -342h222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 932,
    d: "M449 620l-45 17l59 93h72zM205 -10q-36 0 -67.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t44.5 50t68.5 32.5t88 11.5q35 0 70 -5.5t64 -14.5q2 19 5.5 39t11.5 37q-10 54 -47 84t-97 30q-39 0 -81 -16t-86 -46l-24 45q103 68 197 68q65 0 111 -27t69 -77q32 47 84 75.5 t115 28.5q57 0 104.5 -21.5t82 -58t54 -86t19.5 -104.5q0 -4 -0.5 -12.5t-0.5 -11.5h-453q3 -42 20 -77.5t44 -61.5t62 -40.5t74 -14.5q25 0 50 7t46 19t37.5 29.5t25.5 38.5l60 -16q-12 -29 -34 -52.5t-51.5 -41t-64 -27t-72.5 -9.5q-69 0 -124.5 31.5t-90.5 83.5 q-17 -30 -42.5 -52t-56.5 -36t-63.5 -20.5t-62.5 -6.5zM221 42q54 0 98.5 20t67.5 53q16 18 18 35q-10 20 -15 46.5t-6 49.5q-60 20 -125 20q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26.5 -36.5t39.5 -24.5t48.5 -9zM837 282q-3 43 -19.5 78.5t-42.5 61.5t-60 40.5t-74 14.5 t-74 -14.5t-60 -40.5t-41.5 -62t-17.5 -78h389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 751,
    d: "M650 710l-57 -85q54 -53 84.5 -124.5t30.5 -146.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5q-48 0 -90 13t-78 36l-29 -44h-77l55 83q-54 52 -84 123.5t-30 148.5q0 71 25.5 136t70.5 115t106 79.5t132 29.5q48 0 89.5 -13.5t77.5 -36.5l30 45h77zM112 355 q0 -62 21.5 -118t59.5 -98l314 472q-29 19 -62 29.5t-70 10.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108zM638 355q0 61 -22 116.5t-60 97.5l-314 -472q59 -39 133 -39q60 0 109 26t83 68t52.5 95t18.5 108zM382 807l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 595,
    d: "M93 -1l39 51q-44 38 -68.5 92t-24.5 117q0 55 19.5 104t54 86t81.5 59t103 22q38 0 72 -10t63 -29l23 32h47l-41 -54q45 -38 70 -92.5t25 -117.5q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5q-38 0 -72.5 10t-63.5 28l-22 -29h-46zM297 50q39 0 73.5 16.5t60.5 45 t41 66.5t15 82q0 47 -17.5 87t-46.5 69l-224 -336q44 -30 98 -30zM108 258q0 -48 17 -87.5t46 -68.5l224 337q-45 31 -98 31q-39 0 -73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5zM303 620l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM306 918h63l57 -93l-37 -17zM180 918h64l57 -93l-37 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM249 730h63l57 -93l-37 -17zM123 730h64l57 -93l-37 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288zM338 882q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 545,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9zM268 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8 t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    d: "M306 918h63l57 -93l-37 -17zM180 918h64l57 -93l-37 -17zM566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 587,
    d: "M273 730h63l57 -93l-37 -17zM147 730h64l57 -93l-37 -17zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5 t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    d: "M332 882q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 587,
    d: "M299 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85 t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM103 918h63l57 -93l-37 -17zM-23 918h64l57 -93l-37 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 218,
    d: "M90 730h63l57 -93l-37 -17zM-36 730h64l57 -93l-37 -17zM75 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM122 882q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 218,
    d: "M109 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM75 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 751,
    d: "M345 918h63l57 -93l-37 -17zM219 918h64l57 -93l-37 -17zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5z M112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 595,
    d: "M271 730h63l57 -93l-37 -17zM145 730h64l57 -93l-37 -17zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5 t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 751,
    d: "M375 882q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5 t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 595,
    d: "M296 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104 q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 653,
    d: "M295 918h63l57 -93l-37 -17zM169 918h64l57 -93l-37 -17zM89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61 t-11.5 61.5t-31 51.5t-46 35t-55.5 13h-226v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 351,
    d: "M182 730h63l57 -93l-37 -17zM56 730h64l57 -93l-37 -17zM335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 653,
    d: "M322 882q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210 v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61t-11.5 61.5t-31 51.5t-46 35t-55.5 13h-226v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 351,
    d: "M201 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 755,
    d: "M353 918h63l57 -93l-37 -17zM227 918h64l57 -93l-37 -17zM377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66 t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 594,
    d: "M265 730h63l57 -93l-37 -17zM139 730h64l57 -93l-37 -17zM238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5 t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 755,
    d: "M377 882q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5 t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 594,
    d: "M289 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19zM238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60 q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 607,
    d: "M288 -199l17 74h-20v76h63v-76l-25 -74h-35zM504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5q-165 0 -285 103 l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 487,
    d: "M217 -199l17 74h-20v76h63v-76l-25 -74h-35zM248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5t62 29.5 t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 610,
    d: "M276 -199l17 74h-20v76h63v-76l-25 -74h-35zM593 648h-253v-648h-70v648h-253v62h576v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 335,
    d: "M175 -199l17 74h-20v76h63v-76l-25 -74h-35zM325 25q-6 -3 -17.5 -8t-26.5 -10t-34 -9t-40 -4q-22 0 -42 6t-35 18.5t-24 31.5t-9 44v373h-72v54h72v176h68v-176h120v-54h-120v-354q2 -29 20.5 -42.5t42.5 -13.5q29 0 51 9.5t28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 218,
    d: "M-11 -181q-33 0 -62 9t-52 30l34 46q15 -14 34.5 -19t38.5 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-57.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 587,
    d: "M290 -10q-57 0 -104.5 21.5t-82 58t-54.5 85.5t-20 104q0 5 0.5 13t1.5 12h445q-3 42 -19.5 77.5t-42 61t-59.5 40t-71 14.5q-52 0 -97 -25.5t-63 -67.5l-59 16q12 28 34 52t51 41t64 27t73 10q56 0 104 -21.5t83 -59t54.5 -87t19.5 -105.5q0 -55 -19 -103.5t-53.5 -85 t-81.5 -57.5t-104 -21zM290 42q38 0 71.5 14.5t58.5 41t40 62t18 77.5h-382q3 -43 19 -78.5t42.5 -61.5t60.5 -40.5t72 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 544,
    d: "M261 620l-45 17l38 59v34h94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 330,
    d: "M42 645l98 85h50l99 -85l-39 -21l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 330,
    d: "M80 730l85 -63l85 63l39 -20l-99 -86h-50l-98 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 396,
    d: "M54 663v47h289v-47h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 282,
    d: "M141 664q21 0 37.5 19t19.5 47h41q0 -21 -7.5 -39.5t-21 -32t-31.5 -21.5t-38 -8q-42 0 -70 29t-28 72h42q0 -26 17 -46t39 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 162,
    d: "M50 633v97h62v-97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 248,
    d: "M50 665q0 29 21 47t53 18t53 -18t21 -47q0 -30 -21 -48t-53 -18t-53 18t-21 48zM124 703q-17 0 -28.5 -10.5t-11.5 -27.5t11.5 -28t28.5 -11q16 0 28.5 11t12.5 28t-12 27.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 240,
    d: "M130 -175q-37 8 -56 27.5t-19 45.5q0 29 24 58t78 61l22 -17q-45 -28 -63.5 -49.5t-18.5 -43.5q0 -37 52 -44l-19 -38v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 406,
    d: "M264 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5 t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 326,
    d: "M80 620l-37 17l57 93h64zM206 620l-38 17l57 93h64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 326,
    d: "M163 730h63l57 -93l-37 -17zM37 730h64l57 -93l-37 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 282,
    d: "M141 695q-22 0 -39 -20t-17 -46h-42q0 43 28 72t70 29q20 0 38 -8t31.5 -21.5t21 -32t7.5 -39.5h-41q-3 28 -19.5 47t-37.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 647,
    d: "M624 53v-53h-601v53l272 657h58zM547 62l-223 566l-224 -566h447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 763,
    d: "M45 62h191q-85 45 -133.5 125t-48.5 178q0 69 25 132.5t68.5 111.5t103.5 77t130 29t130.5 -29t104 -77t68.5 -111.5t25 -132.5q0 -98 -48.5 -178t-133.5 -125h190v-62h-289v62q49 14 88.5 45t66.5 72.5t41.5 89.5t14.5 96q0 53 -18 104.5t-51.5 92t-81 65t-107.5 24.5 q-59 0 -106.5 -24.5t-81 -65t-51.5 -92t-18 -104.5q0 -48 14.5 -96t41.5 -89.5t66 -72.5t88 -45v-62h-289v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 600,
    d: "M75 521h68v-294q0 -177 123 -177q30 0 58.5 10t53 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19 -2h-14q-23 2 -37 19t-14 45v56q-13 -27 -34 -50t-47.5 -40.5t-56.5 -27.5t-61 -10q-48 0 -78.5 23.5t-44.5 61.5v-287h-64v733z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 589,
    d: "M171 459v-459h-66v459h-80v62h522v-62h-110v-341q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-20 -8 -47 -13t-47 -5q-45 0 -72 26.5t-27 74.5v364h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    d: "M567 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM245 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    d: "M235 820v94h58v-94h-58zM384 820v94h58v-94h-58zM567 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 701,
    d: "M204 648h-187v62h532v-62h-276v-266q34 32 80 48t100 16q105 0 162.5 -59t57.5 -173q0 -109 -53 -166.5t-158 -57.5q-29 0 -56 5t-56 17l21 61q29 -14 49 -18.5t42 -4.5q138 0 138 165q0 168 -156 168q-48 0 -90.5 -17t-80.5 -54v-312h-69v648z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 519,
    d: "M303 807l-45 17l59 93h72zM500 648h-340v-648h-69v710h409v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 700,
    d: "M670 159q-18 -40 -47.5 -70.5t-67 -51.5t-82 -32t-91.5 -11q-77 0 -140 32t-107.5 83.5t-68.5 117t-24 133.5q0 64 22.5 127.5t66 113.5t108 81.5t148.5 31.5q102 0 168.5 -43.5t100.5 -111.5l-56 -34q-18 35 -42.5 59t-53.5 39t-60 21.5t-61 6.5q-63 0 -111 -22 t-81.5 -58.5t-52.5 -83t-23 -95.5h362v-59h-364q4 -56 25 -106t57 -87.5t84.5 -60t106.5 -22.5q31 0 63.5 7.5t62.5 24t56 41t44 59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 607,
    d: "M504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5q-165 0 -285 103l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21 t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 250,
    d: "M90 0v710h70v-710h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 250,
    d: "M90 0v710h70v-710h-70zM22 820v94h58v-94h-58zM171 820v94h58v-94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 483,
    d: "M34 89q22 -15 56.5 -26t77.5 -11q54 0 86.5 19.5t49.5 57.5t22 93.5t5 126.5v361h70v-361q0 -81 -7.5 -147.5t-31.5 -113.5t-70 -73t-124 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 998,
    d: "M6 62q20 1 38.5 8t35.5 25.5t32 51t28 84t23.5 124.5t18.5 173l15 182h361v-301h200q47 0 86 -13.5t66.5 -39.5t43 -64t15.5 -86t-15.5 -86t-43.5 -65t-66.5 -41t-84.5 -14h-270v648h-228l-10 -126q-12 -141 -30.5 -241t-46 -163.5t-66 -93t-90.5 -29.5zM759 61 q36 0 62 11t43.5 30.5t26 46t8.5 57.5t-8 57t-25 45t-44 29.5t-64 10.5h-200v-287h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 1040,
    d: "M525 347h-365v-347h-69v710h69v-301h365v301h69v-301h206q47 0 86 -13.5t66.5 -39.5t43 -64t15.5 -86t-15.5 -86t-43.5 -65t-66.5 -41t-84.5 -14h-276v347zM801 61q36 0 62 11t43.5 30.5t26 46t8.5 57.5t-8 57t-25 45t-44 29.5t-64 10.5h-206v-287h207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 708,
    d: "M599 222q0 85 -33 121.5t-108 36.5q-53 0 -100.5 -17t-84.5 -46v-317h-69v648h-187v62h532v-62h-276v-263q38 26 87 41.5t103 15.5q98 0 151 -50t53 -156v-236h-68v222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 604,
    d: "M328 807l-45 17l59 93h72zM160 395h108l232 315h80l-249 -342l275 -368h-80l-252 333h-114v-333h-69v710h69v-315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 731,
    d: "M279 917h71l60 -93l-44 -17zM160 105l440 605h58v-710h-70v595l-433 -595h-64v710h69v-605z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 622,
    d: "M167 -7q-20 0 -41 3.5t-37 12.5v61q17 -8 36.5 -12t36.5 -4q18 0 33.5 5.5t30 19t28.5 36t29 56.5l-262 539h74l221 -463l214 463h74l-257 -543q-23 -49 -44 -82t-42 -53.5t-43.5 -29.5t-50.5 -9zM317 811q-68 0 -107 28.5t-40 76.5h43q0 -26 29.5 -46t74.5 -20 q43 0 71.5 18.5t32.5 47.5h42q-1 -48 -39.5 -76.5t-106.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 694,
    d: "M91 710h70v-648h372v648h70v-710h-222v-185h-69v185h-221v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 676,
    d: "M309 710h59l295 -710h-74l-92 222h-319l-91 -222h-75zM481 277l-143 351l-145 -351h288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 653,
    d: "M91 710h484v-62h-415v-239h245q47 0 86 -13.5t67 -39.5t43.5 -64t15.5 -86t-15.5 -86t-43 -65t-66.5 -41t-86 -14h-315v710zM406 61q36 0 62.5 11t44 30.5t26 46t8.5 57.5t-8 57t-25 45t-44 29.5t-65 10.5h-245v-287h246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 668,
    d: "M610 183q0 -40 -16 -73.5t-43 -58t-63 -38t-77 -13.5h-335v710h342q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -54 -27 -98.5t-75 -66.5q61 -18 96.5 -67t35.5 -114zM540 195q0 26 -9 50.5t-25.5 43t-39 30t-48.5 11.5h-272v-269h265q27 0 50.5 11t41 29.5t27.5 43 t10 50.5zM146 649v-262h244q26 0 48.5 11t38.5 29t25 41.5t9 49.5q0 27 -8.5 51t-24 41.5t-36.5 28t-46 10.5h-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 519,
    d: "M500 648h-340v-648h-69v710h409v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 706,
    d: "M17 62h16q20 2 37.5 9.5t33 26t29 50t25 83t21.5 124t18 173.5l15 182h372v-648h101v-248h-62v186h-543v-186h-63v248zM515 62v586h-239l-10 -126q-8 -101 -18.5 -177.5t-25 -133t-33.5 -93t-43 -56.5h369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    d: "M567 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 945,
    d: "M241 368l-212 342h80l192 -315h133v315h77v-315h133l191 315h81l-213 -342l239 -368h-81l-207 333h-143v-333h-77v333h-143l-207 -333h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 523,
    d: "M49 626q31 42 79.5 65.5t115.5 23.5q97 0 150.5 -43t53.5 -124q0 -61 -30.5 -103.5t-89.5 -56.5q72 -10 112 -58.5t40 -120.5q0 -47 -18 -86t-49.5 -67.5t-76 -44.5t-96.5 -16q-72 0 -129 30.5t-86 82.5l56 42q23 -42 65 -66.5t98 -24.5q36 0 66.5 10.5t52.5 29.5 t34.5 46t12.5 60q0 71 -54 111.5t-150 40.5h-49v63h49q83 0 128.5 32.5t45.5 91.5q0 55 -37.5 82.5t-97.5 27.5q-50 0 -89 -19.5t-60 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 748,
    d: "M160 105l440 605h58v-710h-70v595l-433 -595h-64v710h69v-605z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 748,
    d: "M530 916q-2 -48 -40.5 -76.5t-106.5 -28.5t-106.5 28.5t-40.5 76.5h43q0 -13 8 -25t22 -21t33 -14.5t42 -5.5q43 0 71.5 18.5t32.5 47.5h42zM160 105l440 605h58v-710h-70v595l-433 -595h-64v710h69v-605z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 604,
    d: "M160 395h108l232 315h80l-249 -342l275 -368h-80l-252 333h-114v-333h-69v710h69v-315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 650,
    d: "M251 522q-12 -141 -30.5 -241t-46 -163.5t-66 -93t-90.5 -29.5l-12 67q20 1 38.5 8t35.5 25.5t32 51t28 84t23.5 124.5t18.5 173l15 182h361v-710h-69v648h-228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 880,
    d: "M719 0v583l-259 -451h-41l-259 451v-583h-70v710h72l277 -486l279 486h71v-710h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 741,
    d: "M650 710v-710h-69v332h-421v-332h-70v710h70v-316h421v316h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 751,
    d: "M376 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM113 355q0 -58 19 -111.5t54 -95t83 -66t107 -24.5 q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 729,
    d: "M91 710h548v-710h-70v648h-409v-648h-69v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 623,
    d: "M90 0v710h294q46 0 84.5 -19.5t66.5 -51t44 -71.5t16 -81q0 -44 -15 -84.5t-42 -71.5t-64.5 -50t-83.5 -19h-230v-262h-70zM160 324h227q31 0 56.5 13.5t43.5 36t28 52t10 61.5q0 33 -11.5 62.5t-31 51.5t-46 34.5t-55.5 12.5h-221v-324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 686,
    d: "M42 360q0 64 22.5 127.5t65.5 113.5t106 81.5t143 31.5q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-64 0 -113 -26t-82.5 -68t-50.5 -94.5t-17 -106.5q0 -59 20.5 -113t56 -95.5t84 -66t105.5 -24.5q30 0 61.5 7.5t61 24t54.5 41 t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-73 0 -134 32t-105 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    d: "M593 648h-253v-648h-70v648h-253v62h576v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 622,
    d: "M167 -7q-20 0 -41 3.5t-37 12.5v61q17 -8 36 -12t37 -4t33.5 5.5t29.5 18.5t28.5 35.5t29.5 57.5l-262 539h74l221 -463l214 463h74l-257 -543q-23 -49 -44 -82t-42 -53.5t-43.5 -29.5t-50.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 741,
    d: "M338 64q-70 4 -126.5 27t-96 62t-61 93t-21.5 122q0 67 21 121.5t60.5 94.5t96 63.5t127.5 28.5v96h70v-96q69 -5 124.5 -28.5t94 -63.5t59 -94.5t20.5 -121.5q0 -68 -21 -122t-59.5 -93t-93.5 -62t-124 -27v-101h-70v101zM408 128q107 9 167.5 71.5t60.5 171.5 t-59.5 170.5t-168.5 69.5v-483zM338 611q-112 -8 -173 -69.5t-61 -170.5q0 -110 62 -172.5t172 -70.5v483z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 632,
    d: "M84 710l233 -310l233 310h77l-273 -360l265 -350h-77l-225 300l-225 -300h-79l265 350l-273 360h79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 724,
    d: "M642 0h-551v710h70v-648h372v648h70v-648h101v-248h-62v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 611,
    d: "M451 710h70v-710h-70v309q-38 -16 -80 -24t-101 -8q-62 0 -105 17.5t-69.5 49t-38.5 76.5t-12 101v189h70v-176q0 -53 8.5 -90t28 -60t50.5 -33.5t77 -10.5q57 0 102.5 11.5t69.5 29.5v329z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 932,
    d: "M841 710v-710h-750v710h69v-648h271v648h70v-648h271v648h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 963,
    d: "M881 0h-790v710h70v-648h271v648h69v-648h272v648h69v-648h101v-248h-62v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 736,
    d: "M16 710h291v-271h167q52 0 95 -14.5t73.5 -42.5t47.5 -69t17 -93q0 -51 -17.5 -92t-48.5 -69.5t-73.5 -43.5t-92.5 -15h-238v648h-221v62zM307 61h168q42 0 72.5 12t50.5 33.5t29.5 50.5t9.5 63t-9.5 63t-29.5 50t-51 33t-73 12h-167v-317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 819,
    d: "M91 710h69v-271h168q52 0 94.5 -14.5t73 -42.5t47.5 -69t17 -93q0 -51 -17.5 -92t-48 -69.5t-73 -43.5t-93.5 -15h-237v710zM160 61h168q42 0 72.5 12t50.5 33.5t29.5 50.5t9.5 63t-9.5 63t-29.5 50t-50.5 33t-72.5 12h-168v-317zM658 0v709h70v-709h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 589,
    d: "M91 710h69v-271h168q52 0 94.5 -14.5t73 -42.5t47.5 -69t17 -93q0 -51 -17.5 -92t-48 -69.5t-73 -43.5t-93.5 -15h-237v710zM160 61h168q42 0 72.5 12t50.5 33.5t29.5 50.5t9.5 63t-9.5 63t-29.5 50t-50.5 33t-72.5 12h-168v-317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 700,
    d: "M318 -6q-47 0 -91.5 11t-82 32t-67 51.5t-47.5 70.5l58 30q18 -35 44 -59.5t56 -41t62.5 -24t63.5 -7.5q58 0 106 22.5t84 60t57 87.5t25 106h-363v59h362q-5 49 -24 95.5t-52.5 83t-81 58.5t-110.5 22q-30 0 -61 -6.5t-60 -21.5t-54 -39t-43 -59l-55 34 q34 68 100.5 111.5t168.5 43.5q84 0 148.5 -31.5t108 -81.5t65.5 -113.5t22 -127.5q0 -68 -24 -133.5t-68.5 -117t-107 -83.5t-139.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 978,
    d: "M610 -5q-67 0 -122.5 24t-96 67.5t-65 104.5t-28.5 135h-137v-326h-70v710h70v-322h137q5 75 30.5 135.5t67.5 103t97 65.5t119 23q72 0 131.5 -27t101.5 -75.5t65.5 -114.5t23.5 -144q0 -82 -24.5 -148.5t-68 -113t-103 -72t-128.5 -25.5zM367 355q0 -69 17.5 -124 t50 -93.5t77.5 -59t99 -20.5q58 0 105 21.5t80 61t50.5 94t17.5 120.5q0 69 -18.5 124t-52.5 93t-80.5 58.5t-101.5 20.5q-56 0 -101 -21.5t-77 -60.5t-49 -93.5t-17 -120.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 632,
    d: "M472 0v285h-188l-172 -285h-82l182 296q-33 11 -59.5 31t-45.5 46.5t-29.5 58.5t-10.5 67q0 40 16 78t45 67.5t69.5 47.5t89.5 18h255v-710h-70zM472 648h-182q-32 0 -60 -11.5t-48.5 -32t-32 -47.5t-11.5 -58q0 -30 10 -57.5t28.5 -48.5t45.5 -33.5t62 -12.5h188v301z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 546,
    d: "M206 -10q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5t16 63t45 50t69 32.5t88 11.5q40 0 81 -7t73 -20v47q0 69 -39 109.5t-108 40.5q-40 0 -82 -16t-85 -46l-24 45q101 68 196 68q98 0 154 -55t56 -152v-235q0 -28 25 -28v-60q-17 -3 -26 -3q-26 0 -40.5 13 t-15.5 36l-2 41q-36 -47 -90.5 -72t-117.5 -25zM222 42q53 0 97.5 20t67.5 53q9 9 13.5 19.5t4.5 19.5v85q-34 13 -70.5 20t-74.5 7q-72 0 -117 -30t-45 -79q0 -24 9.5 -45t26 -36.5t39.5 -24.5t49 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 581,
    d: "M330 645q-88 -20 -139.5 -79.5t-64.5 -168.5q31 48 77 74t106 26q51 0 93 -19t72.5 -52.5t47 -80.5t16.5 -103t-17 -102.5t-49 -79.5t-77.5 -51.5t-102.5 -18.5q-115 0 -175 81t-60 230q0 91 18.5 160t53 118.5t84.5 80t113 45.5l156 36l13 -57zM127 245q0 -42 12 -78.5 t34.5 -63t54 -41.5t70.5 -15t70.5 14.5t54 40.5t34.5 61.5t12 77.5q0 89 -47 141t-127 52q-37 0 -68 -13t-53 -37.5t-34.5 -59.5t-12.5 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 523,
    d: "M333 521q28 0 51.5 -10t41 -27.5t27 -40.5t9.5 -50q0 -18 -4.5 -36t-13.5 -34.5t-23 -30t-33 -21.5q44 -12 69 -46t25 -82q0 -32 -11.5 -58t-32 -45t-48.5 -29.5t-61 -10.5h-251v521h255zM306 291q41 0 65 26t24 66q0 35 -20 61t-62 26h-169v-179h162zM322 51 q21 0 38.5 8t29.5 21.5t19 30.5t7 36q0 36 -24.5 64t-67.5 28h-180v-188h178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 415,
    d: "M394 469h-251v-469h-67v521h318v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 577,
    d: "M18 59h30q22 5 38.5 22.5t29.5 54t23 96t21 148.5l16 141h305v-462h64v-220h-60v161h-410v-161h-57v220zM415 59v408h-176l-15 -116q-17 -124 -36.5 -194t-46.5 -98h274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 752,
    d: "M107 521l136 -234h100v234h68v-234h100l136 234h75l-154 -252l172 -269h-77l-142 235h-110v-235h-68v235h-111l-142 -235h-77l171 269l-154 252h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 409,
    d: "M46 466q28 32 65.5 48t81.5 16q69 0 109 -34t40 -91q0 -46 -24.5 -77t-66.5 -38q56 -8 88 -45.5t32 -93.5q0 -36 -13 -65.5t-37 -50.5t-58 -33t-75 -12q-54 0 -92 19.5t-67 56.5l38 47q23 -32 52.5 -47.5t71.5 -15.5q55 0 84.5 27.5t29.5 74.5q0 52 -36 80t-103 28h-35 v53h35q53 0 83 22.5t30 64.5q0 35 -24 55t-66 20q-30 0 -56.5 -11t-52.5 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 586,
    d: "M143 96l311 425h55v-521h-67v417l-305 -417h-61v521h67v-425z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 585,
    d: "M439 716q-2 -47 -38.5 -71.5t-100.5 -24.5q-65 0 -101 24.5t-39 71.5h43q2 -34 26 -47.5t71 -13.5t70.5 13t26.5 48h42zM143 96l311 425h55v-521h-67v417l-305 -417h-61v521h67v-425z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 484,
    d: "M384 521h76l-197 -252l214 -269h-76l-184 238h-74v-238h-67v521h67v-230h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 538,
    d: "M6 57q28 2 49 15.5t36.5 49t27 97.5t22.5 161l15 141h306v-521h-67v467h-176l-14 -116q-13 -104 -29 -171.5t-37.5 -108t-51.5 -57t-70 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 676,
    d: "M339 170l195 351h66v-521h-66v400l-175 -313h-40l-176 313v-400h-67v521h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 578,
    d: "M143 296h292v225h67v-521h-67v239h-292v-239h-67v521h67v-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 595,
    d: "M297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16t73.5 16.5t60.5 45t41 66.5 t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 563,
    d: "M486 0h-66v462h-277v-462h-67v521h410v-521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 619,
    d: "M342 -10q-66 0 -116.5 33.5t-81.5 84.5v-321h-68v734h61v-101q32 49 83 79.5t111 30.5q54 0 99 -22.5t78 -60t51.5 -86.5t18.5 -101q0 -55 -17 -104t-48.5 -86t-75 -58.5t-95.5 -21.5zM323 50q42 0 76.5 18t59 47.5t37.5 67t13 77.5q0 42 -15 80t-41 67t-61.5 46 t-76.5 17q-26 0 -54.5 -10.5t-53 -28t-42 -41t-21.5 -49.5v-160q12 -28 30.5 -52t42 -41.5t50.5 -27.5t56 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 549,
    d: "M39 262q0 55 19 104t53.5 85.5t82.5 57.5t106 21q74 0 129 -33.5t83 -90.5l-66 -21q-22 40 -61.5 62.5t-87.5 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20 q-11 -28 -32 -51.5t-49.5 -41t-63 -27t-71.5 -9.5q-57 0 -105 21.5t-83 59t-54.5 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 474,
    d: "M270 0h-66v462h-183v59h432v-59h-183v-462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 542,
    d: "M75 -138q15 -14 30 -19t32 -5q13 0 25.5 7.5t25 26t25.5 49.5t29 79l-227 521h70l193 -458l179 458h65l-243 -607q-15 -39 -30.5 -65t-32 -42t-35 -22.5t-40.5 -6.5q-45 0 -69 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 678,
    d: "M374 527q61 -5 110.5 -26.5t83.5 -57t52.5 -82.5t18.5 -103q0 -57 -18.5 -104t-53 -81.5t-83.5 -55t-110 -25.5v-205h-68v204q-62 4 -111 25t-84 56t-53.5 82t-18.5 104q0 56 18.5 103.5t53 83t84 57t111.5 26.5v202h68v-203zM306 463q-94 -8 -145.5 -59.5t-51.5 -142.5 q0 -92 52.5 -145.5t144.5 -61.5v409zM374 54q91 9 143 62t52 145q0 89 -51 141.5t-144 60.5v-409z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 504,
    d: "M88 521l156 -204l8 -15l8 15l156 204h73l-199 -262l199 -259h-73l-156 203l-8 14l-8 -14l-156 -203h-73l199 259l-199 262h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 569,
    d: "M76 521h67v-462h255v462h66v-462h87v-220h-59v161h-416v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 480,
    d: "M404 0h-68v217q-26 -10 -53.5 -14.5t-73.5 -4.5q-47 0 -78.5 14t-51.5 38t-28.5 57.5t-8.5 72.5v141h67v-129q0 -74 29 -104.5t83 -30.5q42 0 71 8.5t44 20.5v235h68v-521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 745,
    d: "M76 0v521h67v-462h196v462h67v-462h196v462h67v-521h-593z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 773,
    d: "M76 521h67v-462h196v462h67v-462h196v462h67v-462h87v-220h-59v161h-621v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 574,
    d: "M255 336h113q36 0 68 -11t56 -32t38 -52.5t14 -72.5t-14 -72.5t-38 -52.5t-56 -32t-68 -11h-179v462h-168v59h234v-185zM368 58q53 0 81 29.5t28 80.5t-29 80.5t-80 29.5h-113v-220h113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 639,
    d: "M76 521h67v-185h113q36 0 68 -11t56 -32t38 -52.5t14 -72.5t-14 -72.5t-38 -52.5t-56 -32t-68 -11h-180v521zM497 521h66v-521h-66v521zM256 58q52 0 80.5 29.5t28.5 80.5t-29 80.5t-80 29.5h-113v-220h113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 461,
    d: "M76 521h67v-185h113q36 0 68 -11t56 -32t38 -52.5t14 -72.5t-14 -72.5t-38 -52.5t-56 -32t-68 -11h-180v521zM256 58q52 0 80.5 29.5t28.5 80.5t-29 80.5t-80 29.5h-113v-220h113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 541,
    d: "M243 -9q-71 0 -130 32.5t-84 93.5l52 23q12 -24 30.5 -42t40.5 -29.5t46 -17.5t47 -6q37 0 70.5 14.5t59 40t42 61t19.5 77.5h-267v55h265q-5 37 -20 70t-39 58t-57.5 40t-73.5 15q-44 0 -88 -20.5t-71 -69.5l-47 27q26 50 77 84t127 34q61 0 109.5 -23t82 -60.5t51 -86 t17.5 -99.5q0 -52 -18 -100.5t-51.5 -86.5t-81.5 -61t-108 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 743,
    d: "M228 292q4 54 23.5 98.5t50.5 75.5t72 48t88 17q54 0 98.5 -20.5t76 -57t49 -86.5t17.5 -108q0 -62 -18.5 -111.5t-51 -84.5t-76.5 -54t-96 -19q-50 0 -91 17.5t-71.5 49t-48.5 76.5t-22 99h-86v-232h-66v521h66v-229h86zM294 260q0 -100 46 -155t122 -55q40 0 72.5 15 t54.5 42.5t34 66t12 86.5q0 99 -48 154.5t-125 55.5q-39 0 -70 -15t-53 -42.5t-33.5 -66.5t-11.5 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 495,
    d: "M171 207q-48 14 -79 51.5t-31 100.5q0 35 13 65t35.5 51.5t54 33.5t69.5 12h186v-521h-67v198h-113l-132 -198h-77zM352 257v205h-116q-21 0 -40.5 -7t-34.5 -20.5t-24 -32.5t-9 -43q0 -46 27.5 -74t72.5 -28h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM204 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    horizAdvX: 587,
    d: "M193 633v94h58v-94h-58zM342 633v94h58v-94h-58zM300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5 q25 0 50 7t46 19t38 29.5t26 38.5l59 -16q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 585,
    d: "M515 -23q0 -34 -12.5 -63t-34 -50t-50 -33t-60.5 -12t-61 9.5t-50 29.5l34 46q13 -13 31.5 -18.5t38.5 -5.5q19 0 36.5 7t30.5 19.5t21 29.5t8 37v286q0 88 -30 132.5t-92 44.5q-33 0 -62 -13.5t-52.5 -37t-40.5 -55.5t-26 -69v-261h-68v592h-73v51h73v87h68v-87h232v-51 h-232v-240q26 68 80 107t123 39q85 0 126.5 -57t41.5 -168v-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 416,
    d: "M232 620l-45 17l59 93h72zM394 469h-251v-469h-67v521h318v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 541,
    d: "M297 -9q-60 0 -108 23t-81 61t-51 86.5t-18 100.5q0 51 17.5 99.5t51 86t81.5 60.5t109 23q77 0 127.5 -34t76.5 -84l-46 -27q-28 50 -72 70t-87 20q-41 0 -74 -15t-57.5 -40t-39.5 -58t-20 -70h266v-55h-268q3 -42 19.5 -77.5t42 -61t59 -40t70.5 -14.5q47 0 93.5 23.5 t71.5 71.5l52 -23q-26 -61 -85 -93.5t-130 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 487,
    d: "M248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5t62 29.5t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40 q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 220,
    d: "M76 0v521h68v-521h-68zM76 630v100h68v-100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 220,
    d: "M7 633v94h58v-94h-58zM156 633v94h58v-94h-58zM76 0v521h68v-521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 227,
    d: "M-2 -181q-33 0 -62 9t-52 30l33 46q16 -14 35 -19t38 -5q18 0 34.5 7t29.5 19.5t21 29.5t8 37v548h68v-544q0 -35 -13 -64t-34.5 -50t-49 -32.5t-56.5 -11.5zM83 630v100h68v-100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 798,
    d: "M6 57q28 2 49 15.5t36.5 49t27 97.5t22.5 161l15 141h306v-208h147q32 0 60 -10t49 -30t33.5 -49.5t12.5 -67.5t-12.5 -67t-33.5 -49t-49 -30t-60 -10h-214v467h-176l-14 -116q-13 -104 -29 -171.5t-37.5 -108t-51.5 -57t-70 -18.5zM609 58q43 0 65.5 26.5t22.5 71.5 t-22.5 72t-65.5 27h-147v-197h147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 800,
    d: "M76 521h67v-208h254v208h67v-208h147q32 0 60 -10t49 -30t33.5 -49.5t12.5 -67.5t-12.5 -67t-33.5 -49t-49 -30t-60 -10h-214v254h-254v-254h-67v521zM611 58q43 0 65.5 26.5t22.5 71.5t-22.5 72t-65.5 27h-147v-197h147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 585,
    d: "M447 259q0 88 -30 132.5t-93 44.5q-32 0 -60.5 -12.5t-52 -35.5t-41 -54.5t-26.5 -69.5v-264h-68v592h-74v51h74v87h68v-87h232v-51h-232v-237q24 66 78 104.5t125 38.5q85 0 126.5 -56.5t41.5 -168.5v-273h-68v259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 484,
    d: "M252 620l-45 17l59 93h72zM384 521h76l-197 -252l214 -269h-76l-184 238h-74v-238h-67v521h67v-230h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 569,
    d: "M143 96l311 425h55v-521h-67v417l-305 -417h-61v521h67v-425zM185 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 542,
    d: "M103 -159q17 -3 28.5 -3t20.5 1q7 1 14.5 5.5t17.5 20.5t24 47.5t34 87.5l-227 521h70l193 -458l179 458h65l-271 -672q-14 -36 -37.5 -53t-60.5 -18q-12 0 -24 0.5t-26 3.5v59zM417 716q-2 -47 -38.5 -71.5t-100.5 -24.5q-65 0 -101 24.5t-39 71.5h43q2 -34 26 -47.5 t71 -13.5t70.5 13t26.5 48h42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 541,
    d: "M237 0h-161v522h67v-463h255v463h66v-522h-161v-161h-66v161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 519,
    d: "M91 710h349l7 170h53v-232h-339v-648h-70v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 425,
    d: "M76 521h275l7 161h45v-215h-260v-467h-67v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 620,
    d: "M490 237v-48h-145v-189h-70v189h-144v48h144v29l-273 444h77l232 -382l233 382h75l-274 -443v-30h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 548,
    d: "M238 0h-135v48h135v4l-231 469h77l190 -407l192 407h75l-234 -469v-4h137v-48h-137v-213h-69v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 715,
    d: "M307 -166v98h62v-98h-62zM89 0v710h241q85 0 148.5 -28t106 -76t64 -112.5t21.5 -137.5q0 -81 -24 -146.5t-68.5 -112t-107 -72t-140.5 -25.5h-241zM600 356q0 64 -18 117.5t-52.5 92.5t-84.5 60.5t-115 21.5h-171v-586h171q66 0 116.5 22.5t84.5 62t51.5 93t17.5 116.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 622,
    d: "M267 -166v98h62v-98h-62zM289 -10q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t95.5 21.5q66 0 117 -34.5t80 -83.5v318h68v-642q0 -28 24 -28v-60q-15 -3 -24 -3q-24 0 -42 15.5t-18 37.5v51q-31 -51 -84 -81t-110 -30zM304 50 q25 0 53.5 10t53.5 27.5t42.5 41t21.5 50.5v161q-10 27 -29 50.5t-43.5 41.5t-52.5 28t-55 10q-42 0 -76 -18t-58.5 -47.5t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5t61.5 -45.5t76.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 738,
    d: "M649 710v-710h-69v332h-421v-332h-70v710h70v-316h421v316h69zM339 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 583,
    d: "M513 0h-68v291q0 89 -30.5 133t-89.5 44q-29 0 -57.5 -11.5t-53.5 -31.5t-43.5 -47t-27.5 -59v-319h-68v730h68v-327q31 59 86 93t119 34q45 0 76 -16.5t51 -46t29 -71t9 -91.5v-305zM266 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 772,
    d: "M358 820v97h62v-97h-62zM159 580v-580h-70v710h54l470 -591v590h70v-709h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 583,
    d: "M265 633v97h62v-97h-62zM513 0h-68v291q0 93 -27.5 135t-84.5 42q-30 0 -60 -11t-55.5 -31t-45.5 -47.5t-29 -59.5v-319h-68v521h62v-118q32 57 91.5 92t129.5 35q43 0 73 -16t48 -45t26 -71t8 -93v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 653,
    d: "M89 0v710h300q46 0 84.5 -19.5t66.5 -51t43.5 -71.5t15.5 -81q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-167 262h-210v-262h-70zM159 324h232q31 0 56.5 13.5t43.5 36.5t28 52t10 61t-11.5 61.5t-31 51.5t-46 35t-55.5 13h-226v-324zM296 -166v98 h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 351,
    d: "M335 461q-69 -2 -120 -38t-72 -99v-324h-68v521h64v-125q29 60 78 94t105 34q8 0 13 -1v-62zM78 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 607,
    d: "M504 577q-30 34 -80 55t-114 21q-94 0 -137 -35.5t-43 -96.5q0 -32 11.5 -52.5t35.5 -35.5t61.5 -26t88.5 -22q57 -12 102.5 -27t77.5 -37.5t49 -54.5t17 -80q0 -49 -19 -85t-53 -60t-81 -35.5t-103 -11.5q-165 0 -285 103l35 57q19 -20 45.5 -38t59 -31.5t69.5 -21 t78 -7.5q85 0 132.5 30.5t47.5 92.5q0 33 -13.5 55.5t-40.5 39t-67 28.5t-93 24q-56 13 -98 27t-71 35t-43.5 50.5t-14.5 72.5q0 49 18.5 87.5t52.5 64t80 39t102 13.5q71 0 126.5 -21.5t100.5 -60.5zM276 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 487,
    d: "M248 -10q-61 0 -119 20t-100 58l31 46q44 -36 89.5 -54t97.5 -18q63 0 100.5 25.5t37.5 72.5q0 22 -10 36.5t-29.5 25.5t-49 19.5t-68.5 17.5q-45 11 -78 22t-54.5 25t-32 34.5t-10.5 51.5q0 39 15.5 69t42 49.5t62 29.5t75.5 10q60 0 109 -19.5t79 -51.5l-33 -40 q-29 30 -70.5 45t-86.5 15q-27 0 -50 -5.5t-40.5 -17.5t-27.5 -30.5t-10 -43.5q0 -21 7 -34t23 -22.5t40.5 -17t59.5 -15.5q50 -12 88 -24t63.5 -28t38.5 -39t13 -56q0 -72 -55 -114t-148 -42zM211 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 610,
    d: "M272 -166v98h62v-98h-62zM593 648h-253v-648h-70v648h-253v62h576v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 335,
    d: "M170 -166v98h62v-98h-62zM325 25q-6 -3 -17.5 -8t-26.5 -10t-34 -9t-40 -4q-22 0 -42 6t-35 18.5t-24 31.5t-9 44v373h-72v54h72v176h68v-176h120v-54h-120v-354q2 -29 20.5 -42.5t42.5 -13.5q29 0 51 9.5t28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1046,
    d: "M356 705h66l100 -252l101 252h67l-124 -303l136 -321l257 629h76l-301 -710h-62l-149 351l-150 -351h-61l-300 710h75l258 -629l135 321zM429 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 813,
    d: "M731 521h67l-224 -521h-56l-112 266l-111 -266h-56l-224 521h66l190 -451l99 238l-89 212h57l68 -170l68 170h58l-89 -212l99 -238zM314 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1046,
    d: "M528 807l-45 17l59 93h72zM356 705h66l100 -252l101 252h67l-124 -303l136 -321l257 629h76l-301 -710h-62l-149 351l-150 -351h-61l-300 710h75l258 -629l135 321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 813,
    d: "M412 620l-45 17l59 93h72zM731 521h67l-224 -521h-56l-112 266l-111 -266h-56l-224 521h66l190 -451l99 238l-89 212h57l68 -170l68 170h58l-89 -212l99 -238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1046,
    d: "M419 820v94h58v-94h-58zM568 820v94h58v-94h-58zM356 705h66l100 -252l101 252h67l-124 -303l136 -321l257 629h76l-301 -710h-62l-149 351l-150 -351h-61l-300 710h75l258 -629l135 321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 813,
    d: "M303 633v94h58v-94h-58zM452 633v94h58v-94h-58zM731 521h67l-224 -521h-56l-112 266l-111 -266h-56l-224 521h66l190 -451l99 238l-89 212h57l68 -170l68 170h58l-89 -212l99 -238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 629,
    d: "M31 55l483 593h-475v62h556v-55l-477 -593h476v-62h-563v55zM292 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 492,
    d: "M31 46l352 424h-344v51h418v-46l-351 -424h350v-51h-425v46zM213 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM295 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM271 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    d: "M566 62v-62h-477v710h468v-62h-398v-256h347v-59h-347v-271h407zM399 825q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7 t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 587,
    d: "M300 -10q-57 0 -104.5 21.5t-82.5 59t-54.5 86.5t-19.5 105q0 55 19.5 103.5t54 85t82.5 58t104 21.5q57 0 104.5 -21.5t81.5 -58.5t53 -85t19 -102v-16t-1 -11h-446q3 -42 19.5 -77.5t42.5 -61.5t59.5 -40.5t71.5 -14.5q25 0 50 7t46 19t38 29.5t26 38.5l59 -16 q-12 -29 -34 -52.5t-51 -41t-64 -27t-73 -9.5zM492 288q-3 42 -19.5 76.5t-42 59.5t-59 39t-71.5 14t-72 -14t-59.5 -39t-41 -60t-18.5 -76h383zM359 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5 t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 248,
    d: "M89 0v710h70v-710h-70zM91 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 218,
    d: "M75 0v521h68v-521h-68zM75 630v100h68v-100h-68zM77 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 751,
    d: "M343 -166v98h62v-98h-62zM375 -5q-74 0 -135.5 30.5t-105.5 81t-68 115.5t-24 133q0 71 25.5 136t70.5 115t106 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -131.5q0 -71 -25.5 -136t-70 -114.5t-105.5 -79t-132 -29.5zM112 355q0 -58 19 -111.5t54 -95 t83 -66t107 -24.5q60 0 109 26t83 68t52.5 95t18.5 108q0 58 -19.5 111.5t-54.5 94.5t-83 65.5t-106 24.5q-60 0 -109 -25.5t-83 -67.5t-52.5 -95t-18.5 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 595,
    d: "M266 -166v98h62v-98h-62zM297 -10q-57 0 -104 21.5t-81.5 58.5t-53.5 86t-19 103q0 55 19.5 104t54 86t81.5 59t103 22t103.5 -22t82 -59t54 -86t19.5 -104q0 -54 -19 -103t-53.5 -86t-82 -58.5t-104.5 -21.5zM108 258q0 -44 15 -81.5t40.5 -66t60 -44.5t73.5 -16 t73.5 16.5t60.5 45t41 66.5t15 82q0 43 -15 81.5t-41 67t-60.5 45t-73.5 16.5t-73 -16.5t-60 -45.5t-41 -67.5t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 755,
    d: "M377 58q67 0 111.5 25.5t71 67t37 94.5t10.5 107v358h70v-358q0 -72 -16 -136.5t-51.5 -113.5t-92.5 -78t-139 -29q-84 0 -141.5 30.5t-92.5 80.5t-50 114t-15 132v358h69v-358q0 -56 11 -109t37.5 -94t70.5 -66t110 -25zM349 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 594,
    d: "M238 -10q-85 0 -126.5 56.5t-41.5 168.5v306h68v-294q0 -177 121 -177q30 0 59 10t53.5 29t44 45t31.5 59v328h68v-433q0 -28 24 -28v-60q-12 -2 -19.5 -2h-10.5q-24 1 -39 17t-15 43v60q-34 -61 -92.5 -94.5t-124.5 -33.5zM254 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 651,
    d: "M93 710l232 -382l234 382h76l-275 -446v-264h-70v266l-274 444h77zM232 917h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 542,
    d: "M105 -160q8 -1 15.5 -1.5t14.5 -0.5q18 0 28.5 5t20.5 22t22.5 49t35.5 86l-227 521h70l193 -458l179 458h65l-270 -672q-11 -29 -36.5 -50.5t-69.5 -21.5q-10 0 -19 0.5t-22 2.5v60zM185 730h71l60 -93l-44 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 651,
    d: "M93 710l232 -382l234 382h76l-275 -446v-264h-70v266l-274 444h77zM387 825q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7 t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 542,
    d: "M105 -160q8 -1 15.5 -1.5t14.5 -0.5q18 0 28.5 5t20.5 22t22.5 49t35.5 86l-227 521h70l193 -458l179 458h65l-270 -672q-11 -29 -36.5 -50.5t-69.5 -21.5q-10 0 -19 0.5t-22 2.5v60zM340 638q-23 0 -39.5 6t-31 13.5t-28 14t-29.5 6.5q-17 0 -26.5 -7t-15 -15.5t-7 -16 t-1.5 -9.5h-42q0 5 3.5 20.5t13.5 31.5t28 28.5t46 12.5q21 0 36.5 -6.5t29.5 -14.5t28.5 -14.5t33.5 -6.5t30.5 7t17.5 16t7.5 16.5t1.5 9.5h42q0 -5 -4 -20t-14.5 -31t-30 -28.5t-49.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 579
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 916
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 570,
    d: "M65 241v63h439v-63h-439z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 901,
    d: "M65 241v63h771v-63h-771z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 196,
    d: "M124 730l-17 -106h24v-103h-67v103l25 106h35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 190,
    d: "M71 521l17 106h-24v103h67v-103l-25 -106h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 225,
    d: "M86 -104l17 104h-23v102h66v-102l-25 -104h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 316,
    d: "M124 730l-17 -106h24v-103h-67v103l25 106h35zM245 730l-17 -106h24v-103h-67v103l25 106h35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 311,
    d: "M71 521l17 106h-24v103h67v-103l-25 -106h-35zM192 521l17 106h-24v103h67v-103l-25 -106h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 343,
    d: "M86 -104l17 104h-23v102h66v-102l-25 -104h-35zM204 -104l17 104h-23v102h66v-102l-25 -104h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 406,
    d: "M171 -130v370h-132v62h132v473h65v-473h131v-62h-131v-370h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 410,
    d: "M173 -130v289h-132v63h132v110h-132v63h132v380h65v-380h131v-63h-131v-110h131v-63h-131v-289h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 351,
    d: "M265 346q0 -38 -26 -64t-63 -26t-63.5 26t-26.5 64q0 18 7 34t19.5 28.5t29 19.5t34.5 7t34.5 -7t28.5 -19.5t19 -28.5t7 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 457,
    d: "M65 0v98h59v-98h-59zM200 0v98h57v-98h-57zM334 0v98h58v-98h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1066,
    d: "M196 433q-31 0 -58.5 11t-47.5 30.5t-32 45.5t-12 56t12 56t32 45.5t47.5 31t58.5 11.5t58 -11.5t47.5 -31t32 -45.5t11.5 -56t-11.5 -56t-32 -45.5t-47.5 -30.5t-58 -11zM196 472q20 0 38 8.5t31.5 23t21 33t7.5 39.5q0 22 -8 41t-21.5 33t-31.5 22t-37 8 q-21 0 -39 -8.5t-31.5 -23t-21 -33t-7.5 -39.5t8 -40t21.5 -33.5t31.5 -22.5t38 -8zM531 -10q-31 0 -58 11t-47.5 30.5t-32 46t-11.5 56.5t11.5 56t32 45.5t47.5 30.5t58 11t58.5 -11t47.5 -30.5t32 -45.5t12 -56t-12 -56.5t-32 -46t-47.5 -30.5t-58.5 -11zM531 30 q21 0 38.5 8.5t31 22.5t21 33t7.5 40t-8 40t-21.5 33.5t-31.5 22.5t-37 8q-20 0 -38 -8.5t-31.5 -23t-21 -33t-7.5 -39.5q0 -22 8 -41t21.5 -33t31 -22t37.5 -8zM883 -10q-31 0 -58 11t-47.5 30.5t-32 46t-11.5 56.5t11.5 56t32 45.5t47.5 30.5t58 11t58.5 -11t47.5 -30.5 t32 -45.5t12 -56t-12 -56.5t-32 -46t-47.5 -30.5t-58.5 -11zM883 30q21 0 39 8.5t31.5 22.5t21 33t7.5 40t-8 40t-21.5 33.5t-31.5 22.5t-38 8t-38 -8.5t-31.5 -23t-21 -33t-7.5 -39.5q0 -22 8 -41t21.5 -33t31 -22t37.5 -8zM71 27l279 340l272 347l35 -30l-279 -340 l-273 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 352,
    d: "M41 276l248 178v-59l-193 -136l193 -134v-59l-248 173v37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 352,
    d: "M312 239l-249 -173v59l193 134l-193 136v59l249 -178v-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 154,
    d: "M-216 27l279 340l272 347l35 -30l-279 -340l-273 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 458,
    d: "M230 406q-48 0 -84 19t-60 48.5t-36 65t-12 69.5q0 36 13.5 72t38 65t60 47t80.5 18q47 0 82.5 -19.5t59.5 -49t36 -65t12 -68.5q0 -37 -13 -73t-37.5 -64.5t-60 -46.5t-79.5 -18zM84 608q0 -28 9.5 -56t28 -50.5t45.5 -37t63 -14.5q37 0 64 15.5t45 38.5t27 51t9 53 q0 28 -9.5 56t-28.5 50.5t-46 37t-61 14.5q-37 0 -64.5 -15.5t-45.5 -39t-27 -51t-9 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 384,
    d: "M252 411v103h-228v42l242 254h31v-253h57v-43h-57v-103h-45zM72 557h181v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 374,
    d: "M189 665q32 0 60 -9.5t48.5 -26t32.5 -39.5t12 -51q0 -30 -13 -54.5t-35 -42t-51.5 -27t-62.5 -9.5q-50 0 -89.5 20t-59.5 55l30 25q18 -26 49.5 -42t71.5 -16q48 0 81 24.5t33 66.5q0 22 -10 39t-25.5 28t-35.5 17t-40 6q-31 0 -59 -13t-44 -34h-41q4 18 12 51.5t16 69 t15 65.5t9 42h224v-44h-190l-32 -131q36 30 94 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 403,
    d: "M371 540q0 -29 -13 -54t-35 -44t-52.5 -29.5t-64.5 -10.5q-74 0 -120 45t-46 126q0 119 47 178t125 59q45 0 81.5 -18.5t54.5 -52.5l-27 -29q-14 26 -44 42t-67 16q-57 0 -92 -41.5t-36 -117.5q15 30 51 47.5t76 17.5q34 0 64 -10.5t51.5 -28.5t34 -42.5t12.5 -52.5z M207 443q25 0 47 7.5t38.5 21t26 30.5t9.5 37t-9.5 37.5t-26 30.5t-39 20.5t-47.5 7.5t-47 -7.5t-38.5 -20.5t-26 -30.5t-9.5 -36.5q0 -20 10 -37.5t26.5 -31t38.5 -21t47 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 355,
    d: "M275 766h-249v44h321l-235 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 398,
    d: "M359 522q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5t-33 37.5t-12 45.5q0 19 8 35t21 29t29.5 22t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 42.5t33.5 32t46.5 20.5t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52 t-54.5 -32q40 -13 66.5 -39t26.5 -64zM314 527q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5t-42 -5.5t-37 -16t-26 -24.5t-10 -32t10.5 -32.5t27 -24.5t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM99 705q0 -15 9 -27t23 -20t32 -12t35 -4q18 0 36 4t32.5 12.5 t23.5 20t9 26.5t-8.5 26.5t-23 19.5t-32.5 12t-37 4q-39 0 -69 -16.5t-30 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 403,
    d: "M32 672q0 29 13 54t35 44t52 29.5t65 10.5q73 0 119.5 -45t46.5 -126q0 -120 -47 -178.5t-125 -58.5q-45 0 -81.5 19t-55.5 53l28 28q14 -26 43.5 -42t67.5 -16q57 0 92 41.5t36 117.5q-15 -29 -50.5 -47.5t-77.5 -18.5q-34 0 -63.5 10.5t-51 29t-34 43t-12.5 52.5z M196 769q-25 0 -46.5 -7.5t-38 -21t-26 -31t-9.5 -36.5q0 -20 9.5 -37t26 -30.5t38.5 -21t47 -7.5t46.5 7.5t38 20.5t26 30.5t9.5 36.5t-9.5 37t-26 31t-38.5 21t-47 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 458,
    d: "M230 -85q-48 0 -84 19t-60 48.5t-36 65t-12 69.5q0 36 13.5 72t38 65t60 47t80.5 18q47 0 82.5 -19.5t59.5 -49t36 -65t12 -68.5q0 -37 -13 -73t-37.5 -64.5t-60 -46.5t-79.5 -18zM84 117q0 -28 9.5 -56t28 -50.5t45.5 -37t63 -14.5q37 0 64 15.5t45 39t27 51t9 52.5 q0 28 -9.5 56t-28.5 50.5t-46 37t-61 14.5q-37 0 -64.5 -15.5t-45.5 -38.5t-27 -51t-9 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 287,
    d: "M266 -36v-44h-217v44h89v309q-6 -7 -18 -15t-26.5 -15.5t-30.5 -12.5t-29 -5v44q17 0 35 8.5t33 18.5t25 19t11 10h45v-361h83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 391,
    d: "M36 -80q0 39 7.5 67.5t23.5 50.5t39.5 38t55.5 28q23 9 47 17t44 19.5t33 27t13 38.5q0 31 -25.5 53t-76.5 22q-25 0 -45 -5.5t-36 -14t-27.5 -18.5t-18.5 -18l-30 32q4 5 16.5 16t32.5 22.5t48.5 20t65.5 8.5q73 0 109.5 -34t36.5 -85q0 -31 -14 -52.5t-35 -36 t-45.5 -23.5t-45.5 -16q-35 -11 -58 -25t-36.5 -29t-19.5 -30.5t-6 -28.5h261v-44h-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 391,
    d: "M190 -85q-63 0 -105 23.5t-50 65.5l27 28q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 55t-108.5 20h-23v40h23q63 0 99 16.5t36 50.5q0 16 -8.5 29t-23 22.5t-34 14.5t-40.5 5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17 q33 0 61 -8.5t49 -23t32.5 -34.5t11.5 -43q0 -69 -91 -89q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46t-35 -34t-51.5 -21.5t-61.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 384,
    d: "M252 -80v103h-228v42l242 254h31v-252h57v-44h-57v-103h-45zM72 67h181v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 374,
    d: "M189 174q32 0 60 -9t48.5 -26t32.5 -40.5t12 -51.5q0 -29 -13 -53.5t-35 -42t-51.5 -27t-62.5 -9.5q-50 0 -89.5 20.5t-59.5 53.5l30 26q18 -26 49.5 -42t71.5 -16q48 0 81 25t33 66q0 22 -10 39t-25.5 28t-35.5 17t-40 6q-31 0 -59 -13t-44 -34h-41q4 18 12 51.5t16 69 t15 65.5t9 42h224v-44h-190l-32 -130q35 29 94 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 404,
    d: "M371 52q0 -29 -12.5 -53.5t-35 -43.5t-52.5 -29.5t-65 -10.5q-73 0 -119.5 45t-46.5 126q0 119 47.5 177.5t125.5 58.5q45 0 81 -18.5t55 -52.5l-28 -29q-14 26 -43.5 42t-66.5 16q-57 0 -92 -41t-36 -118q15 30 50.5 48t76.5 18q34 0 63.5 -10.5t51.5 -29t34 -43 t12 -52.5zM208 -44q25 0 46.5 7.5t38 20.5t26 30.5t9.5 36.5q0 20 -9.5 37.5t-26 31t-38.5 21t-47 7.5t-47 -7.5t-38.5 -21t-26 -31t-9.5 -36.5q0 -20 10 -37t26.5 -30.5t38.5 -21t47 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 355,
    d: "M276 275h-250v44h321l-235 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 398,
    d: "M359 31q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5t-33 37.5t-12 45.5q0 19 8 35.5t21 29t29.5 21.5t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 43t33.5 32t46.5 20t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52t-54.5 -32 q40 -13 66.5 -39t26.5 -64zM314 36q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5t-42 -5.5t-37 -16t-26 -25t-10 -32.5t10.5 -32t27 -24t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM99 213q0 -15 9 -26.5t23 -19.5t32 -12t35 -4q18 0 36 4.5t32.5 12.5t23.5 19.5 t9 26.5t-8.5 26.5t-23 19.5t-32.5 12.5t-37 4.5q-20 0 -37.5 -4.5t-31.5 -13t-22 -20t-8 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 405,
    d: "M33 185q0 28 12.5 53t35 44t52 29.5t64.5 10.5q74 0 120.5 -45t46.5 -126q0 -119 -47 -177.5t-125 -58.5q-45 0 -82 18.5t-55 52.5l28 29q14 -26 43.5 -42t66.5 -16q57 0 92.5 41.5t35.5 116.5q-7 -15 -20 -27t-30 -20.5t-37 -13t-40 -4.5q-34 0 -63.5 10.5t-51 28.5 t-34 42.5t-12.5 53.5zM196 281q-24 0 -46 -7.5t-38.5 -21t-26 -31t-9.5 -36.5q0 -20 10 -37t26.5 -30t38.5 -20.5t46 -7.5q25 0 47 7.5t38.5 20.5t26 30t9.5 37q0 19 -10 36.5t-26.5 31t-38.5 21t-47 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 551,
    d: "M229 0q-42 12 -77 37t-60 59.5t-38.5 77t-13.5 88.5t13.5 88t38 76t59.5 58.5t78 35.5v125h37v-117q8 1 16.5 1.5t17.5 0.5h14.5t14.5 -2v117h37v-123q51 -12 88 -42t59 -74l-67 -21q-22 40 -61 62.5t-87 22.5q-40 0 -74.5 -16t-60 -43.5t-40 -65.5t-14.5 -83 q0 -44 15 -83t41 -67.5t60.5 -45t73.5 -16.5q25 0 49.5 7t45.5 19.5t36 28.5t21 34l67 -20q-17 -45 -57.5 -76.5t-94.5 -44.5v-118h-37v112q-7 -1 -14 -1.5t-14 -0.5q-9 0 -18 0.5t-17 1.5v-112h-37v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 612,
    d: "M121 0v134h-92v54h92v522h465v-62h-396v-261h335v-58h-335v-141h133v-54h-133v-134h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 488,
    d: "M49 393h83q-20 37 -38.5 72.5t-18.5 78.5q0 36 14.5 67t39 54t57.5 36.5t70 13.5q55 0 103 -28t78 -77l-39 -42q-24 42 -63 66t-81 24q-24 0 -45 -9t-36.5 -25t-24.5 -37.5t-9 -46.5q0 -39 19.5 -74t39.5 -73h187v-43h-167q5 -14 9.5 -29t6.5 -32h157v-42h-155 q-2 -47 -25.5 -91t-78.5 -102q37 9 73 9q21 0 39 -3t35 -6t33.5 -6t34.5 -3q20 0 41 4.5t49 13.5l17 -52q-54 -26 -110 -26q-22 0 -42 3.5t-40 8t-40.5 8.5t-43.5 4q-24 0 -53.5 -4.5t-54.5 -12.5l-19 50q33 33 56.5 60t38 51.5t21.5 47.5t8 46h-113v42h110q-6 34 -19 61 h-104v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 843,
    d: "M805 376h-86v-62h86v-43h-86v-271h-61l-216 271h-247v-271h-70v271h-88v43h88v62h-88v43h88v291h54l231 -291h239v290h70v-290h86v-43zM195 314h212l-49 62h-163v-62zM494 314h155v62h-205zM195 419h128l-128 161v-161zM649 119v152h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1118,
    d: "M41 361h154l-29 69h-125v42h107l-100 238h75l98 -238h266l-95 233h66l100 -252l101 252h67l-96 -233h267l98 238h76l-101 -238h106v-42h-124l-29 -69h153v-43h-171l-135 -318h-62l-149 351l-150 -351h-61l-135 318h-172v43zM738 81l97 237h-198zM381 81l99 237h-196z M602 402l17 -41h233l28 69h-267zM504 430h-266l28 -69h232l18 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 801,
    d: "M140 416q9 57 35 110.5t68.5 95.5t100 67t129.5 25q95 0 162.5 -43t99.5 -112l-55 -34q-17 35 -41.5 59t-52.5 39t-58 21.5t-59 6.5q-55 0 -99 -19.5t-76.5 -52t-53.5 -75t-29 -88.5h338l-18 -43h-325v-17q0 -23 3 -45h304l-19 -43h-276q12 -45 36.5 -83.5t57.5 -67 t73.5 -44.5t86.5 -16q30 0 61.5 7.5t61 24t54.5 41t42 59.5l58 -30q-17 -40 -48 -70.5t-69 -51.5t-80.5 -32t-83.5 -11q-61 0 -113.5 22.5t-94 60t-70.5 87t-43 104.5h-114l18 43h88q-3 24 -3 49v13h-74l18 43h60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 473,
    d: "M435 556h-99q11 -36 11 -69q0 -39 -11.5 -74.5t-32 -64t-49.5 -48t-65 -26.5l174 -274h-79l-206 324h62q31 0 56.5 13.5t43.5 36.5t27.5 52t9.5 61q0 18 -4 35.5t-11 33.5h-219v42h193q-20 23 -46.5 36.5t-56.5 13.5h-90v62h392v-43h-176q18 -14 32.5 -31.5t25.5 -37.5 h118v-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 309,
    d: "M200 55q12 0 27.5 4t29.5 9l12 -55q-20 -8 -46.5 -13.5t-48.5 -5.5q-48 0 -75 26.5t-27 77.5v512q0 28 9 51.5t25 41t37.5 27.5t46.5 10q50 0 80.5 -36t30.5 -94q0 -39 -14 -87t-37.5 -96t-53.5 -92.5t-63 -75.5v-141q0 -29 18 -46t49 -17zM245 604q0 39 -14 60t-40 21 t-42 -20.5t-16 -54.5v-278q22 27 42 62.5t35.5 73t25 73t9.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1140,
    d: "M159 580v-580h-70v710h54l470 -591v590h70v-709h-61zM941 348q-40 0 -73 15t-57 40t-37 58t-13 69q0 37 13 70t37 58t57 39.5t73 14.5t73 -14.5t57 -39.5t37.5 -58t13.5 -70q0 -36 -13 -69t-37 -58t-57.5 -40t-73.5 -15zM818 529q0 -28 9.5 -52t26.5 -42t39 -28t48 -10 q25 0 47.5 10.5t39.5 28.5t26.5 42.5t9.5 52.5t-9.5 52t-26.5 42t-39.5 28t-47.5 10t-47.5 -10.5t-39 -28.5t-26.5 -42.5t-10 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 716,
    d: "M578 710h67v-286h-48v217l-84 -175h-40l-84 175v-217h-48v286h66l86 -187zM253 641q-11 14 -32 22.5t-47 8.5q-62 0 -62 -36q0 -17 14 -26.5t56 -18.5q25 -5 45 -12t34 -17.5t21.5 -25.5t7.5 -37q0 -41 -31.5 -60t-81.5 -19q-71 0 -123 43l23 36q15 -15 41 -25.5 t60 -10.5q61 0 61 33q0 20 -16 30t-60 20q-49 11 -74.5 28.5t-25.5 56.5q0 41 31 62.5t80 21.5q32 0 56 -8.5t44 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 727,
    d: "M300 664h-95v-240h-48v240h-95v48h238v-48zM583 710h67v-286h-48v217l-84 -175h-40l-84 175v-217h-48v286h66l85 -187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 763,
    d: "M45 62h191q-85 45 -133.5 125t-48.5 178q0 69 25 132.5t68.5 111.5t103.5 77t130 29t130.5 -29t104 -77t68.5 -111.5t25 -132.5q0 -98 -48.5 -178t-133.5 -125h190v-62h-289v62q49 14 88.5 45t66.5 72.5t41.5 89.5t14.5 96q0 53 -18 104.5t-51.5 92t-81 65t-107.5 24.5 q-59 0 -106.5 -24.5t-81 -65t-51.5 -92t-18 -104.5q0 -48 14.5 -96t41.5 -89.5t66 -72.5t88 -45v-62h-289v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 603,
    d: "M306 22q69 0 116.5 22t76.5 53l22 -24q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-430v-150q30 -38 73 -60.5t93 -22.5zM306 499q-50 0 -93 -23t-73 -62v-125 h335v124q-31 40 -74.5 63t-94.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 859,
    d: "M102 27l279 340l272 347l35 -30l-279 -340l-273 -348zM263 371v-45h-201v45h81v309q-5 -6 -16 -14.5t-24.5 -16t-28.5 -13t-27 -5.5v45q16 0 33 8t31 18t23 19t9 10h45v-360h75zM662 -5q-63 0 -105 23.5t-50 65.5l27 28q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7 q49 0 83 19.5t34 51.5q0 35 -40.5 55t-108.5 20h-23v40h23q63 0 99 16.5t36 50.5q0 16 -8.5 29t-23 22.5t-34 14.5t-40.5 5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17q33 0 61 -8.5t49 -23t32.5 -34.5t11.5 -43q0 -69 -91 -89q47 -7 74.5 -35.5t27.5 -66.5 q0 -26 -13 -46t-35 -34t-51.5 -21.5t-61.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 871,
    d: "M44 327q0 39 7.5 67.5t23 50t38.5 37.5t54 28q22 9 46 17.5t43.5 19.5t32 27t12.5 39q0 31 -25 52.5t-75 21.5q-24 0 -44 -5.5t-35 -14t-26.5 -18t-18.5 -17.5l-29 31q4 5 15.5 16.5t31.5 23t48 20t64 8.5q72 0 107 -34t35 -85q0 -31 -14 -52.5t-34.5 -36t-44.5 -23.5 t-44 -16q-34 -11 -56.5 -25t-35.5 -29t-18.5 -30.5t-5.5 -29.5h249v-43h-301zM154 27l279 340l272 347l35 -30l-279 -340l-273 -348zM674 -5q-63 0 -105 23.5t-50 65.5l27 28q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 55t-108.5 20h-23 v40h23q63 0 99 16.5t36 50.5q0 16 -8.5 29t-23 22.5t-34 14.5t-40.5 5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17q33 0 61 -8.5t49 -23t32.5 -34.5t11.5 -43q0 -69 -91 -89q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46t-35 -34t-51.5 -21.5t-61.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 858,
    d: "M114 27l279 340l272 347l35 -30l-279 -340l-273 -348zM261 371v-45h-201v45h81v309q-5 -6 -16 -14.5t-24.5 -16t-28.5 -13t-27 -5.5v45q16 0 33 8t31 18t23 19t9 10h45v-360h75zM822 111q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5 t-33 37.5t-12 45.5q0 19 8 35.5t21 29t29.5 21.5t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 43t33.5 32t46.5 20t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52t-54.5 -32q40 -13 66.5 -39t26.5 -64zM777 116q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5 t-42 -5.5t-37 -16t-26 -25t-10 -32.5t10.5 -32t27 -24t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM562 293q0 -15 9 -26.5t23 -19.5t32 -12t35 -4q18 0 36 4.5t32.5 12.5t23.5 19.5t9 26.5t-8.5 26.5t-23 19.5t-32.5 12.5t-37 4.5q-20 0 -37.5 -4.5t-31.5 -13 t-22 -20t-8 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 863,
    d: "M198 321q-63 0 -105 24t-50 65l27 29q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 54.5t-108.5 19.5h-23v41h23q63 0 99 16.5t36 49.5t-31.5 52.5t-74.5 19.5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17q33 0 61 -8.5 t49 -23t32.5 -34.5t11.5 -44q0 -69 -91 -88q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46.5t-35 -34.5t-51.5 -21.5t-61.5 -7.5zM139 27l279 340l272 347l35 -30l-279 -340l-273 -348zM827 111q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5 t-33 37.5t-12 45.5q0 19 8 35.5t21 29t29.5 21.5t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 43t33.5 32t46.5 20t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52t-54.5 -32q40 -13 66.5 -39t26.5 -64zM782 116q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5 t-42 -5.5t-37 -16t-26 -25t-10 -32.5t10.5 -32t27 -24t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM567 293q0 -15 9 -26.5t23 -19.5t32 -12t35 -4q18 0 36 4.5t32.5 12.5t23.5 19.5t9 26.5t-8.5 26.5t-23 19.5t-32.5 12.5t-37 4.5q-20 0 -37.5 -4.5t-31.5 -13 t-22 -20t-8 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 866,
    d: "M194 585q32 0 60 -9.5t48.5 -26t32.5 -39.5t12 -51q0 -30 -13 -54.5t-35 -42t-51.5 -27t-62.5 -9.5q-50 0 -89.5 20t-59.5 55l30 25q18 -26 49.5 -42t71.5 -16q48 0 81 24.5t33 66.5q0 22 -10 39t-25.5 28t-35.5 17t-40 6q-31 0 -59 -13t-44 -34h-41q4 18 12 51.5t16 69 t15 65.5t9 42h224v-44h-190l-32 -131q36 30 94 30zM132 27l279 340l272 347l35 -30l-279 -340l-273 -348zM831 111q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5t-33 37.5t-12 45.5q0 19 8 35.5t21 29t29.5 21.5t33.5 15q-30 11 -53 31.5 t-23 51.5q0 24 13 43t33.5 32t46.5 20t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52t-54.5 -32q40 -13 66.5 -39t26.5 -64zM786 116q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5t-42 -5.5t-37 -16t-26 -25t-10 -32.5t10.5 -32t27 -24t37.5 -15t41 -5 q21 0 42 5.5t37 15.5t26 24t10 32zM571 293q0 -15 9 -26.5t23 -19.5t32 -12t35 -4q18 0 36 4.5t32.5 12.5t23.5 19.5t9 26.5t-8.5 26.5t-23 19.5t-32.5 12.5t-37 4.5q-20 0 -37.5 -4.5t-31.5 -13t-22 -20t-8 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 849,
    d: "M68 27l279 340l272 347l35 -30l-279 -340l-273 -348zM813 111q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5t-33 37.5t-12 45.5q0 19 8 35.5t21 29t29.5 21.5t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 43t33.5 32t46.5 20t52 7t52 -7 t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52t-54.5 -32q40 -13 66.5 -39t26.5 -64zM768 116q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5t-42 -5.5t-37 -16t-26 -25t-10 -32.5t10.5 -32t27 -24t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM553 293q0 -15 9 -26.5 t23 -19.5t32 -12t35 -4q18 0 36 4.5t32.5 12.5t23.5 19.5t9 26.5t-8.5 26.5t-23 19.5t-32.5 12.5t-37 4.5q-20 0 -37.5 -4.5t-31.5 -13t-22 -20t-8 -26.5zM292 686h-249v44h321l-235 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 566,
    d: "M247 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 47 19.5 90.5t53.5 76.5t78.5 52.5t94.5 19.5q62 0 108.5 -31t61.5 -87q4 23 5.5 51t1.5 51q0 66 -11.5 111.5t-32.5 73.5t-51 40t-67 12q-46 0 -88 -16t-63 -42l-39 41q33 38 85 57.5t111 19.5q109 0 164.5 -74 t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM248 50q39 0 72 16t57 41.5t37.5 57.5t13.5 65q0 30 -12 57t-32.5 47.5t-48.5 32t-60 11.5q-36 0 -69 -14.5t-58 -38.5t-40 -56.5t-15 -68.5q0 -32 11.5 -59t32.5 -47.5t49.5 -32t61.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 614,
    d: "M608 53v-53h-601v53l272 657h58zM531 62l-223 566l-224 -566h447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 691,
    d: "M513 648h-334v-738h-66v738h-82v62h628v-62h-80v-738h-66v738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 529,
    d: "M479 653h-349v-4l202 -280l-217 -301v-4h379v-64h-462v51l226 309l-220 304v46h441v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 539,
    d: "M68 267v56h403v-56h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 588,
    d: "M-8 30l563 684l42 -34l-564 -684z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 189,
    d: "M65 246v112h59v-112h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 447,
    d: "M11 365h140l71 -303l118 728h66l-148 -790h-75l-89 314h-83v51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 691,
    d: "M202 517q29 0 51 -8.5t38.5 -22.5t29.5 -33t24 -40q11 21 24 40t30 33t38.5 22.5t50.5 8.5q36 0 65 -13t49 -35.5t31 -53t11 -64.5t-12 -64t-33 -52.5t-49.5 -35.5t-62.5 -13q-27 0 -48.5 8t-38 21.5t-29.5 31t-24 37.5q-10 -20 -22.5 -37.5t-30 -31t-40 -21.5t-52.5 -8 q-31 0 -59.5 13t-50 35.5t-34.5 53t-13 64.5t12 64t33 52.5t50 35.5t62 13zM202 241q23 0 41 8.5t32 23.5t25.5 35t22.5 42q-11 22 -22 42.5t-25.5 35.5t-32 24t-41.5 9q-18 0 -36 -6.5t-32.5 -19.5t-23.5 -34t-9 -49q0 -29 9 -49.5t23.5 -34.5t32.5 -20.5t36 -6.5zM488 241 q18 0 36.5 6.5t32.5 20.5t23 34.5t9 49.5q0 28 -9 49t-23 34t-32.5 19.5t-36.5 6.5q-24 0 -42 -9.5t-31.5 -25t-24 -36.5t-20.5 -44q10 -21 21.5 -40.5t25.5 -33.5t31 -22.5t40 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 300,
    d: "M98 710q-2 47 23.5 78.5t73.5 31.5q21 0 48.5 -6t48.5 -15l-17 -48q-14 6 -31 10t-28 4q-26 0 -42 -18.5t-14 -52.5l41 -751q3 -52 -22.5 -81t-73.5 -29q-22 0 -49 6t-47 15l16 48q14 -6 30 -10t28 -4q26 0 42.5 18.5t14.5 53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 432,
    d: "M367 324q-13 -15 -33 -26t-49 -11q-24 0 -43 6.5t-35 14.5t-31.5 14.5t-31.5 6.5q-18 0 -29.5 -7t-17.5 -16l-32 36q11 16 30 27t48 11q22 0 39 -6.5t33 -14.5t32 -14.5t36 -6.5t33 5.5t21 13.5zM367 207q-13 -14 -33 -24t-49 -10q-24 0 -43 6.5t-35 14.5t-31.5 14.5 t-31.5 6.5q-18 0 -29.5 -7t-17.5 -16l-32 36q11 16 30 27.5t48 11.5q22 0 39 -6.5t33 -14.5t32 -14.5t36 -6.5t33 5t21 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 467,
    d: "M83 358h174l66 116l34 -16l-57 -100h84v-49h-111l-38 -66h149v-49h-177l-65 -116l-34 15l57 101h-82v49h109l38 66h-147v49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 450,
    d: "M63 61v57h322v-57h-322zM62 383l318 159v-66l-219 -111l219 -109v-68l-318 157v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 450,
    d: "M65 61v57h323v-57h-323zM389 345l-319 -157v68l220 109l-220 111v66l319 -159v-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 506,
    d: "M289 730l186 -364l-186 -366h-73l-186 366l186 364h73zM411 354l-160 322l-151 -301l160 -322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 154,
    d: "M60 -199l17 74h-20v76h63v-76l-25 -74h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 811,
    d: "M800 25q-6 -3 -17.5 -8t-27 -10.5t-33.5 -9t-37 -3.5q-47 0 -79 24.5t-32 75.5v373h-73v54h73q0 56 -3.5 92.5t-13.5 58t-28.5 30t-48.5 8.5q-32 0 -53.5 -8t-35 -21.5t-19.5 -31.5t-6 -39q0 -28 7.5 -54t17 -46t18.5 -33.5l11 -16.5l-32 -40q-32 35 -71 47t-75 12 q-25 0 -49 -5t-42.5 -16t-30 -29.5t-11.5 -45.5q0 -30 14 -48t35.5 -28t46.5 -14t47 -7q36 -5 71.5 -12t64 -22.5t46.5 -41t18 -65.5q0 -42 -17.5 -71t-46 -48t-65 -27.5t-73.5 -8.5q-64 0 -120.5 22t-94.5 54l30 47q88 -71 185 -71q24 0 49 5t45 16.5t32.5 30t12.5 45.5 q0 30 -15.5 47t-39 26.5t-50.5 13.5t-50 7q-38 6 -72 14t-59.5 23.5t-40.5 40t-15 62.5q0 42 17 72t44.5 49t61.5 27.5t69 8.5q32 0 65.5 -7.5t58.5 -23.5q-13 28 -23 52t-10 59q0 28 8.5 52.5t27.5 43.5t50.5 30t76.5 11q53 0 83 -14t44.5 -42.5t18 -71t3.5 -98.5h118v-54 h-118v-354q0 -29 18.5 -42.5t44.5 -13.5q13 0 25.5 3t23 6.5t18.5 7.5t11 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 384,
    d: "M252 0v103h-228v42l242 254h31v-252h57v-44h-57v-103h-45zM72 147h181v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 272,
    d: "M250 371v-45h-201v45h81v309q-5 -6 -16 -14.5t-24.5 -16t-28.5 -13t-27 -5.5v45q16 0 33 8t31 18t23 19t9 10h45v-360h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 391,
    d: "M36 0q0 39 7.5 67.5t23.5 50.5t39.5 38t55.5 28q23 9 47 17t44 19.5t33 27t13 38.5q0 31 -25.5 53t-76.5 22q-25 0 -45 -5.5t-36 -14t-27.5 -18.5t-18.5 -18l-30 32q4 5 16.5 16t32.5 22.5t48.5 20t65.5 8.5q73 0 109.5 -34t36.5 -85q0 -31 -14 -52.5t-35 -35.5 t-45.5 -23t-45.5 -16q-34 -11 -56 -25.5t-35 -29.5t-18 -30.5t-5 -28.5h255v-44h-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 390,
    d: "M190 321q-63 0 -105 24t-50 65l27 29q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 54.5t-108.5 19.5h-23v41h23q63 0 99 16.5t36 49.5t-31.5 52.5t-74.5 19.5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17q33 0 61 -8.5 t49 -23t32.5 -34.5t11.5 -44q0 -69 -91 -88q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46.5t-35 -34.5t-51.5 -21.5t-61.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 222,
    d: "M94 620l-45 17l59 93h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 162,
    d: "M50 -166v98h62v-98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 391,
    d: "M190 -5q-63 0 -105 23.5t-50 65.5l27 28q1 -12 11 -25t26.5 -23.5t39.5 -17.5t50 -7q49 0 83 19.5t34 51.5q0 35 -40.5 55t-108.5 20h-23v40h23q63 0 99 16.5t36 50.5q0 16 -8.5 29t-23 22.5t-34 14.5t-40.5 5q-42 0 -72 -15.5t-45 -40.5l-30 34q18 29 58.5 46t88.5 17 q33 0 61 -8.5t49 -23t32.5 -34.5t11.5 -43q0 -69 -91 -89q47 -7 74.5 -35.5t27.5 -66.5q0 -26 -13 -46t-35 -34t-51.5 -21.5t-61.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 388,
    d: "M36 327q0 39 7.5 67.5t23.5 50t39.5 37.5t55.5 28q23 9 47 17.5t44 19.5t33 27t13 39q0 31 -25.5 52.5t-76.5 21.5q-25 0 -45 -5.5t-36 -14t-27.5 -18t-18.5 -17.5l-30 31q4 5 16 16.5t32.5 23t49 20t65.5 8.5q73 0 109.5 -34t36.5 -85q0 -31 -14.5 -52.5t-35.5 -36 t-45.5 -23.5t-45.5 -16q-35 -11 -58 -25t-36.5 -29t-19 -30.5t-5.5 -29.5h255v-43h-308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 398,
    d: "M359 111q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5t-33 37.5t-12 45.5q0 19 8 35.5t21 29t29.5 21.5t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 43t33.5 32t46.5 20t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52 t-54.5 -32q40 -13 66.5 -39t26.5 -64zM314 116q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5t-42 -5.5t-37 -16t-26 -25t-10 -32.5t10.5 -32t27 -24t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM99 293q0 -15 9 -26.5t23 -19.5t32 -12t35 -4q18 0 36 4.5t32.5 12.5 t23.5 19.5t9 26.5t-8.5 26.5t-23 19.5t-32.5 12.5t-37 4.5q-20 0 -37.5 -4.5t-31.5 -13t-22 -20t-8 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 374,
    d: "M189 585q32 0 60 -9.5t48.5 -26t32.5 -39.5t12 -51q0 -30 -13 -54.5t-35 -42t-51.5 -27t-62.5 -9.5q-50 0 -89.5 20t-59.5 55l30 25q18 -26 49.5 -42t71.5 -16q48 0 81 24.5t33 66.5q0 22 -10 39t-25.5 28t-35.5 17t-40 6q-31 0 -59 -13t-44 -34h-41q4 18 12 51.5t16 69 t15 65.5t9 42h224v-44h-190l-32 -131q36 30 94 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 355,
    d: "M275 686h-249v44h321l-235 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 570,
    d: "M84 0v548h253q39 0 72 -15t56.5 -40t37 -56t13.5 -63q0 -29 -9.5 -56t-27 -48.5t-41.5 -37t-54 -21.5l146 -211h-72l-138 199h-174v-199h-62zM146 255h193q25 0 46 9.5t36 26t23 38t8 45.5t-9.5 45t-25.5 37.5t-37.5 26t-46.5 9.5h-187v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 593,
    d: "M543 197q0 -47 -20 -84.5t-54 -64.5t-79.5 -41.5t-95.5 -14.5q-53 0 -98 16.5t-77.5 45t-50.5 66.5t-18 81q0 34 12.5 63t32.5 51.5t45.5 39t51.5 25.5q-24 10 -45 24.5t-37 33.5t-25.5 42t-9.5 49q0 44 20 77.5t51.5 56.5t71 35t79.5 12t79.5 -12t71 -34.5t51.5 -56.5 t20 -77q0 -26 -9.5 -49t-26 -42.5t-38 -34t-45.5 -24.5q29 -10 55 -27.5t45.5 -40.5t31 -52t11.5 -63zM474 202q0 36 -16 63.5t-42 46.5t-58 29t-63 10q-33 0 -64 -10.5t-56 -30t-40 -47.5t-15 -62q0 -35 16 -62.5t41.5 -46.5t57 -29t63.5 -10t63.5 10.5t56.5 30t40.5 47 t15.5 61.5zM143 526q0 -29 14 -51.5t36 -38t49.5 -23.5t53.5 -8q27 0 54 8t49.5 24t36.5 39t14 52q0 28 -13 50.5t-34.5 38t-49.5 23.5t-58 8q-29 0 -56.5 -8.5t-48.5 -24t-34 -38.5t-13 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 398,
    d: "M359 442q0 -26 -13 -47.5t-35 -36.5t-51.5 -23.5t-62.5 -8.5q-35 0 -64 9.5t-50 25.5t-33 37.5t-12 45.5q0 19 8 35t21 29t29.5 22t33.5 15q-30 11 -53 31.5t-23 51.5q0 24 13 42.5t33.5 32t46.5 20.5t52 7t52 -7t46.5 -20t33 -31.5t12.5 -42.5q0 -31 -22.5 -52 t-54.5 -32q40 -13 66.5 -39t26.5 -64zM314 447q0 18 -10.5 32.5t-27 24.5t-37 15.5t-41.5 5.5t-42 -5.5t-37 -16t-26 -24.5t-10 -32t10.5 -32.5t27 -24.5t37.5 -15t41 -5q21 0 42 5.5t37 15.5t26 24t10 32zM99 625q0 -15 9 -27t23 -20t32 -12t35 -4q18 0 36 4t32.5 12.5 t23.5 20t9 26.5t-8.5 26.5t-23 19.5t-32.5 12t-37 4q-39 0 -69 -16.5t-30 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 525,
    d: "M429 438q-26 26 -67 42t-94 16q-76 0 -111 -25.5t-35 -70.5q0 -23 9.5 -38t30 -26t51 -19t72.5 -17q46 -10 83.5 -21t64 -28.5t40.5 -42.5t14 -62q0 -39 -16 -67.5t-44.5 -47t-67.5 -27.5t-85 -9q-137 0 -238 78l31 52q33 -32 86.5 -53.5t122.5 -21.5q67 0 106 22t39 67 q0 24 -11.5 40.5t-33.5 29t-55.5 21.5t-76.5 18q-46 10 -81 21t-58 27.5t-35 40t-12 57.5q0 38 16 67.5t44 49.5t66.5 30t84.5 10q115 0 189 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 230,
    d: "M84 0v547h62v-547h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 829,
    d: "M552 0l-137 418l-139 -418h-71l-183 521h71l150 -436l139 436h65l139 -436l150 436h71l-183 -521h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 543,
    d: "M523 521l-292 -734h-76q0 1 9 24t22 55.5t28 68.5t27 65l-227 521h72l192 -458l179 458h66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 531,
    d: "M487 56v-56h-403v548h395v-56h-333v-187h291v-52h-291v-197h341z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 458,
    d: "M230 -5q-48 0 -84 19t-60 48.5t-36 65t-12 69.5q0 36 13.5 72t38 65t60 47t80.5 18q47 0 82.5 -19.5t59.5 -49t36 -65t12 -68.5q0 -37 -13 -73t-37.5 -64.5t-60 -46.5t-79.5 -18zM84 197q0 -28 9.5 -56t28 -50.5t45.5 -37t63 -14.5q37 0 64 15.5t45 39t27 51t9 52.5 q0 28 -9.5 56t-28.5 50.5t-46 37t-61 14.5q-37 0 -64.5 -15.5t-45.5 -38.5t-27 -51t-9 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 684,
    d: "M342 -10q-72 2 -127 36t-92 86t-56 115t-19 123q0 64 20.5 128.5t58.5 116t92.5 83.5t122.5 32q73 0 127.5 -34.5t91.5 -87.5t55.5 -116.5t18.5 -121.5q0 -65 -20.5 -129t-58.5 -115t-92 -83t-122 -33zM119 350q1 -52 16 -105t42.5 -95.5t69 -69.5t95.5 -27q56 0 98 28.5 t69.5 72.5t41.5 96.5t14 99.5q0 52 -15 105t-43.5 95.5t-70 69.5t-94.5 27q-57 0 -98.5 -29t-69.5 -73t-41.5 -96t-13.5 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 458,
    d: "M230 326q-48 0 -84 19t-60 48.5t-36 65t-12 69.5q0 36 13.5 72t38 65t60 47t80.5 18q47 0 82.5 -19.5t59.5 -49t36 -65t12 -68.5q0 -37 -13 -73t-37.5 -64.5t-60 -46.5t-79.5 -18zM84 528q0 -28 9.5 -56t28 -50.5t45.5 -37t63 -14.5q37 0 64 15.5t45 38.5t27 51t9 53 q0 28 -9.5 56t-28.5 50.5t-46 37t-61 14.5q-37 0 -64.5 -15.5t-45.5 -39t-27 -51t-9 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 531,
    d: "M508 492h-211v-492h-62v492h-213v56h486v-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 374,
    d: "M189 254q32 0 60 -9t48.5 -26t32.5 -40.5t12 -51.5q0 -29 -13 -53.5t-35 -42t-51.5 -27t-62.5 -9.5q-50 0 -89.5 20.5t-59.5 53.5l30 26q18 -26 49.5 -42t71.5 -16q48 0 81 25t33 66q0 22 -10 39t-25.5 28t-35.5 17t-40 6q-31 0 -59 -13t-44 -34h-41q4 18 12 51.5t16 69 t15 65.5t9 42h224v-44h-190l-32 -130q35 29 94 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 556,
    d: "M283 451q48 0 90.5 -16.5t73.5 -46.5t49 -71.5t18 -91.5q0 -53 -19.5 -96t-52.5 -74t-78 -48t-96 -17q-76 0 -136.5 37t-91.5 100l46 34q27 -50 76 -79.5t107 -29.5q37 0 69 12.5t56 35t37.5 54.5t13.5 70q0 37 -13 67.5t-36 52.5t-54 34.5t-67 12.5q-47 0 -88.5 -21 t-67.5 -59h-64q1 6 5.5 26.5t10.5 50t13 64.5t14 71q17 84 37 187h343v-63h-292l-50 -255q26 29 64 44t83 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 652,
    d: "M325 53q55 0 91.5 19t58.5 49.5t30.5 69.5t8.5 80v277h62v-277q0 -56 -13.5 -105.5t-43 -87.5t-77 -60t-116.5 -22q-71 0 -119 23.5t-77 61.5t-42 87.5t-13 102.5v277h62v-277q0 -42 9.5 -81t31 -69.5t57.5 -49t90 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 569,
    d: "M375 0v190h-349v61l370 459h47v-458h88v-62h-88v-190h-68zM99 252h282v352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 579,
    d: "M533 141q0 -31 -13.5 -57t-36.5 -44.5t-53.5 -29t-65.5 -10.5h-280v548h289q31 0 56 -12t42 -32t26.5 -45t9.5 -51q0 -42 -22 -76t-62 -51q51 -14 80.5 -51.5t29.5 -88.5zM470 152q0 19 -7.5 37t-21 32t-32 22t-39.5 8h-224v-197h218q22 0 41.5 8t33.5 21.5t22.5 31.5 t8.5 37zM146 492v-190h201q21 0 39.5 7.5t31.5 20.5t20.5 30.5t7.5 36.5q0 41 -26 68t-68 27h-206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 384,
    d: "M252 331v103h-228v42l242 254h31v-253h57v-43h-57v-103h-45zM72 477h181v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 588,
    d: "M84 548l211 -461l209 461h66l-249 -548h-54l-249 548h66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1062,
    d: "M1041 710l-226 -710h-73l-214 597l-208 -597h-73l-226 710h78l190 -609l200 609h76l208 -609l190 609h78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 425,
    d: "M38 76q18 -11 47.5 -19.5t65.5 -8.5q45 0 71.5 14.5t41 42.5t18.5 69t4 95v278h62v-278q0 -63 -6 -114t-26.5 -87t-59.5 -56t-105 -20q-78 0 -130 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 900,
    d: "M307 544h59l83 -192l84 192h59l-105 -237l111 -231l215 472h69l-253 -548h-55l-124 264l-124 -264h-56l-252 548h68l216 -472l108 231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 218,
    d: "M75 517h68v-730h-68v730zM75 721h68v-91h-68v91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 562,
    d: "M84 0v547h62v-309l324 310h70l-244 -241l256 -307h-68l-226 270l-112 -102v-168h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 553,
    d: "M83 548l193 -233l193 233h70l-229 -278l222 -270h-69l-187 225l-186 -225h-70l222 270l-229 278h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 595,
    d: "M44 278q0 49 19 98t55 88t89 63t121 24q80 0 136.5 -33.5t84.5 -86.5l-50 -32q-14 27 -34 45t-43 29.5t-48 16t-49 4.5q-53 0 -94 -19.5t-68.5 -50.5t-41.5 -70t-14 -79q0 -44 16.5 -84.5t46 -71.5t70 -49t87.5 -18q25 0 51 5.5t50.5 17.5t45 31t34.5 45l53 -29 q-15 -30 -41 -54t-58.5 -40t-68.5 -24.5t-70 -8.5q-62 0 -113 24.5t-88 64.5t-57.5 90.5t-20.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 562,
    d: "M88 548l193 -290l194 290h69l-232 -346v-202h-63v203l-229 345h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 229,
    d: "M81 730h68v-730h-68v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 495,
    d: "M84 0v548h62v-492h331v-56h-393z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 552,
    d: "M37 49l401 443h-395v56h469v-50l-397 -442h396v-56h-474v49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 405,
    d: "M33 265q0 28 12.5 53t35 44t52 29.5t64.5 10.5q74 0 120.5 -45t46.5 -126q0 -119 -47 -177.5t-125 -58.5q-45 0 -82 18.5t-55 52.5l28 29q14 -26 43.5 -42t66.5 -16q57 0 92.5 41.5t35.5 116.5q-7 -15 -20 -27t-30 -20.5t-37 -13t-40 -4.5q-34 0 -63.5 10.5t-51 28.5 t-34 42.5t-12.5 53.5zM196 361q-24 0 -46 -7.5t-38.5 -21t-26 -31t-9.5 -36.5q0 -20 10 -37t26.5 -30t38.5 -20.5t46 -7.5q25 0 47 7.5t38.5 20.5t26 30t9.5 37q0 19 -10 36.5t-26.5 31t-38.5 21t-47 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 603,
    d: "M44 471q0 51 19.5 95.5t53 77.5t79.5 52t99 19q56 0 103 -20t80.5 -58.5t52.5 -93.5t19 -124q0 -109 -19 -189.5t-53.5 -134t-82.5 -79.5t-107 -26q-70 0 -126 35t-85 98l43 39q21 -51 66.5 -81t102.5 -30q44 0 80 20.5t62 60.5t40 97t14 131q-22 -59 -75.5 -94 t-121.5 -35q-51 0 -95.5 19t-77.5 51.5t-52 76t-19 93.5zM294 656q-38 0 -71.5 -14.5t-58.5 -40t-39.5 -59t-14.5 -70.5q0 -38 14.5 -71.5t40 -59t59 -40t71.5 -14.5t71.5 14.5t59 40t40.5 58.5t15 71q0 37 -15 71t-40.5 59t-59.5 40t-72 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 620,
    d: "M287 -10q-55 0 -100.5 22t-78 59t-50.5 86t-18 102q0 55 18.5 104.5t51.5 86.5t77 58.5t95 21.5q66 0 116.5 -33.5t79.5 -85.5v106h68v-517h-68v105q-29 -52 -78.5 -83.5t-112.5 -31.5zM478 336q-11 29 -29.5 53.5t-41.5 42.5t-50.5 28t-57.5 10q-42 0 -77 -18.5 t-60 -48.5t-38.5 -68t-13.5 -76q0 -42 14 -80t39.5 -66.5t60.5 -45.5t77 -17q63 0 108.5 37t68.5 91v158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 403,
    d: "M32 592q0 29 13 54t35 44t52 29.5t65 10.5q73 0 119.5 -45t46.5 -126q0 -120 -47 -178.5t-125 -58.5q-45 0 -81.5 19t-55.5 53l28 28q14 -26 43.5 -42t67.5 -16q57 0 92 41.5t36 117.5q-15 -29 -50.5 -47.5t-77.5 -18.5q-34 0 -63.5 10.5t-51 29t-34 43t-12.5 52.5z M196 689q-25 0 -46.5 -7.5t-38 -21t-26 -31t-9.5 -36.5q0 -20 9.5 -37t26 -30.5t38.5 -21t47 -7.5t46.5 7.5t38 20.5t26 30.5t9.5 36.5t-9.5 37t-26 31t-38.5 21t-47 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 542,
    d: "M408 0v82q-36 -48 -90 -70t-112 -22q-37 0 -68.5 12.5t-55 34.5t-36.5 51.5t-13 63.5q0 41 19.5 71t51 49t70 28t77.5 9q54 0 94 -9t60 -18v47q0 68 -39 109t-108 41q-40 0 -81.5 -16t-85.5 -46l-24 45q45 29 94 48.5t103 19.5q51 0 90 -15t65.5 -42.5t40 -65.5t13.5 -84 v-323h-65zM388 115q17 20 17 39v85q-71 27 -145 27q-28 0 -56.5 -6t-52 -19t-38.5 -33.5t-15 -50.5q0 -26 10 -47t27 -36t39.5 -23.5t47.5 -8.5q46 0 93 17.5t73 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 757,
    d: "M611 0v435l-214 -335h-36l-215 335v-435h-62v548h65l230 -364l230 364h65v-548h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 669,
    d: "M146 431v-431h-62v548h48l390 -439v438h63v-547h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 287,
    d: "M266 44v-44h-217v44h89v309q-6 -7 -18 -15t-26.5 -15.5t-30.5 -12.5t-29 -5v44q17 0 35 8.5t33 18.5t25 19t11 10h45v-361h83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 416,
    d: "M396 62v-62h-331v62h135v581q-8 -12 -26.5 -26.5t-41 -28t-46.5 -22.5t-44 -9v64q17 0 35.5 7t36 17.5t33 23t27 23.5t18.5 18.5t8 8.5h69v-657h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 513,
    d: "M84 0v548h392v-56h-330v-190h280v-54h-280v-248h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 649,
    d: "M325 -4q-63 0 -115 23.5t-88.5 62.5t-57 89t-20.5 103q0 54 21.5 104.5t59 88.5t89 61t111.5 23q63 0 114.5 -24t88.5 -63.5t57 -89.5t20 -101q0 -55 -21.5 -105t-59 -88.5t-88.5 -61t-111 -22.5zM107 274q0 -43 16 -83t44.5 -70.5t68.5 -49t89 -18.5q50 0 90 19 t68.5 50.5t43.5 71t15 80.5q0 43 -16 83t-45 70.5t-68.5 48.5t-87.5 18q-50 0 -90 -19t-68.5 -50.5t-44 -71t-15.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 617,
    d: "M276 -10q-53 0 -96.5 22.5t-74.5 60t-48 86t-17 101.5q0 54 19 103t52.5 86t79 59t97.5 22q30 0 58.5 -8.5t53.5 -23t45.5 -35t35.5 -44.5v102h61v-734h-68v321q-38 -58 -88 -88t-110 -30zM297 50q30 0 56.5 10t49 26.5t40.5 39t31 47.5v161q-4 27 -21 51.5t-41.5 43.5 t-53.5 30t-57 11q-42 0 -77.5 -18t-61 -47.5t-39.5 -67.5t-14 -78q0 -42 14 -80t39 -66.5t59.5 -45.5t75.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 732,
    d: "M380 -5q-74 0 -136 30.5t-107 81t-70 116t-25 134.5q0 70 25 134.5t69.5 114t106.5 79.5t136 30q89 0 158.5 -42t112.5 -111l-55 -45q-15 25 -36.5 49.5t-49.5 43.5t-61.5 30.5t-72.5 11.5q-60 0 -108.5 -26t-83 -68t-53 -95.5t-18.5 -108.5q0 -56 19 -109t53.5 -94.5 t83 -67t107.5 -25.5q51 0 94.5 19t76.5 51t54.5 73t29.5 85h-208v63h283v-7.5t-0.5 -12t-0.5 -12.5v-9q-6 -62 -32 -119t-68.5 -100t-99.5 -68.5t-124 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 880,
    d: "M869 25q-6 -3 -17 -8t-26 -10t-34 -9t-40 -4q-22 0 -42 6t-35 18.5t-24 31.5t-9 44v373h-72v54h72q0 59 -4 96t-15.5 57.5t-32.5 28t-55 7.5q-52 0 -76 -31t-24 -75q0 -26 10 -55t22.5 -56.5t25.5 -50.5t19 -36l-66 -21q-25 45 -64.5 65t-88.5 20q-43 0 -77.5 -18 t-58.5 -48t-36.5 -68t-12.5 -77q0 -42 15 -80t41 -66.5t61 -45.5t75 -17q21 0 44.5 6t45 17.5t38 28t22.5 37.5l67 -20q-12 -31 -34.5 -55t-52 -40.5t-63 -25t-67.5 -8.5q-59 0 -107 23t-82.5 60.5t-53 86t-18.5 99.5q0 53 18 102t51 86.5t80.5 60t106.5 22.5 q50 0 84.5 -11.5t62.5 -32.5q-14 25 -28.5 55.5t-14.5 65.5q0 61 38.5 100.5t113.5 39.5q60 0 92 -17t47 -47t17.5 -71.5t2.5 -90.5h119v-54h-119v-354q2 -29 20.5 -42.5t42.5 -13.5q29 0 50.5 10t28.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 619,
    d: "M510 76q-81 -80 -188 -80q-60 0 -111 24t-88 63t-58 89.5t-21 103.5q0 55 20.5 104.5t57.5 87.5t87.5 60.5t110.5 22.5q88 0 143 -33t84 -86l-49 -33q-28 50 -75 73t-105 23q-48 0 -87 -18.5t-66.5 -49.5t-42.5 -71t-15 -82q0 -45 17 -85t46.5 -70.5t69.5 -48t86 -17.5 q102 0 184 88v82h-131v48h185v-271h-54v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 355,
    d: "M276 355h-250v44h321l-235 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 521,
    d: "M414 647h-383v63h491l-360 -710h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 404,
    d: "M371 132q0 -29 -12.5 -53.5t-35 -43.5t-52.5 -29.5t-65 -10.5q-73 0 -119.5 45t-46.5 126q0 119 47.5 177.5t125.5 58.5q45 0 81 -18.5t55 -52.5l-28 -29q-14 26 -43.5 42t-66.5 16q-57 0 -92 -41t-36 -118q15 30 50.5 48t76.5 18q34 0 63.5 -10.5t51.5 -29t34 -43 t12 -52.5zM208 36q25 0 46.5 7.5t38 20.5t26 30.5t9.5 36.5q0 20 -9.5 37.5t-26 31t-38.5 21t-47 7.5t-47 -7.5t-38.5 -21t-26 -31t-9.5 -36.5q0 -20 10 -37t26.5 -30.5t38.5 -21t47 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 603,
    d: "M559 234q0 -51 -19.5 -95.5t-53.5 -77.5t-80 -52t-99 -19q-56 0 -103 20.5t-80.5 58.5t-52.5 93.5t-19 124.5q0 108 19 188.5t53.5 134t82.5 79.5t107 26q71 0 127 -35t85 -97l-44 -40q-21 51 -66 81.5t-102 30.5q-44 0 -80 -21t-61.5 -60.5t-40 -97.5t-14.5 -131 q22 59 75.5 94t121.5 35q51 0 95.5 -18.5t77.5 -51t52 -76.5t19 -94zM309 50q38 0 71.5 14.5t59 39.5t40 58.5t14.5 71.5t-15 71.5t-40.5 58.5t-59 39.5t-71.5 14.5t-71.5 -14.5t-59 -39.5t-40 -58.5t-14.5 -71.5t15 -71t40.5 -58.5t59 -40t71.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 403,
    d: "M371 460q0 -29 -13 -54t-35 -44t-52.5 -29.5t-64.5 -10.5q-74 0 -120 45t-46 126q0 119 47 178t125 59q45 0 81.5 -18.5t54.5 -52.5l-27 -29q-14 26 -44 42t-67 16q-57 0 -92 -41.5t-36 -117.5q15 30 51 47.5t76 17.5q34 0 64 -10.5t51.5 -28.5t34 -42.5t12.5 -52.5z M207 363q25 0 47 7.5t38.5 21t26 30.5t9.5 37t-9.5 37.5t-26 30.5t-39 20.5t-47.5 7.5t-47 -7.5t-38.5 -20.5t-26 -30.5t-9.5 -36.5q0 -20 10 -37.5t26.5 -31t38.5 -21t47 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 621,
    d: "M84 0v548h204q72 0 125.5 -21.5t89.5 -58.5t54 -86.5t18 -106.5q0 -63 -20.5 -113.5t-58 -86.5t-90.5 -55.5t-118 -19.5h-204zM511 275q0 48 -14.5 87.5t-43 68.5t-70 45t-95.5 16h-142v-436h142q55 0 96.5 16.5t69.5 46t42.5 69.5t14.5 87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 316,
    d: "M104 0v459h-77v62h77v176h69v-176h124v-62h-124v-459h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 584,
    d: "M285 -9q-47 0 -88 12t-72 33.5t-51 52t-26 67.5l42 38q2 -26 16.5 -51t40 -44.5t61 -31.5t77.5 -12q38 0 70.5 10t56.5 28t37.5 43.5t13.5 55.5q0 33 -16 59t-46 44.5t-72 28t-94 9.5h-34v59h34q98 0 153.5 32t55.5 96q0 31 -13 56.5t-35.5 43.5t-52.5 28t-63 10 q-66 0 -113 -29t-66 -72l-47 46q14 27 37.5 48.5t53 36.5t64 23t70.5 8q51 0 94 -15t74.5 -41.5t49.5 -62.5t18 -78q0 -61 -35.5 -100.5t-103.5 -56.5q36 -7 65 -23.5t49.5 -40.5t31.5 -54t11 -63q0 -45 -20 -80.5t-54 -60.5t-79 -38.5t-95 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 618,
    d: "M475 0v97q-30 -48 -79.5 -77.5t-106.5 -29.5q-54 0 -100 22.5t-79 59.5t-51.5 85.5t-18.5 101.5q0 55 18 104.5t49.5 86.5t75 58.5t94.5 21.5q66 0 116 -34.5t82 -83.5v318h68v-730h-68zM475 340q-9 27 -28.5 51t-44 41.5t-52.5 27.5t-55 10q-42 0 -76 -18t-58.5 -47.5 t-37.5 -67.5t-13 -78q0 -42 15 -80t41 -66.5t61.5 -45.5t76.5 -17q26 0 55 10t53.5 27.5t42 41t20.5 50.5v161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 581,
    d: "M48 0v14q0 66 13 114.5t37.5 85t60.5 63t82 48.5q34 16 71 31t68 35.5t51 49.5t20 73q0 28 -9.5 53.5t-28 45t-47.5 31t-68 11.5t-70.5 -10.5t-56 -25.5t-42.5 -33t-30 -33l-45 44q6 7 24.5 27t50 41t75.5 37.5t101 16.5q55 0 96.5 -16.5t69 -44.5t41.5 -65t14 -78 q0 -51 -19.5 -87.5t-50.5 -62.5t-69 -44t-75 -34q-56 -24 -92.5 -49.5t-58.5 -53.5t-30.5 -58.5t-8.5 -63.5h405v-62h-479z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 586,
    d: "M17 0l250 548h52l248 -548h-66l-76 165h-265l-75 -165h-68zM293 470l-118 -250h234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 543,
    d: "M84 0v548h247q39 0 72 -15t57 -40t37 -56t13 -63q0 -34 -12.5 -65.5t-35 -56t-54.5 -39t-71 -14.5h-191v-199h-62zM146 255h188q26 0 47 9.5t35.5 25.5t22.5 38t8 46t-9.5 45.5t-25.5 37.5t-38 25.5t-46 9.5h-182v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 590,
    d: "M449 0v114q-31 -58 -87.5 -91t-120.5 -33q-51 0 -84.5 18.5t-52.5 49t-26.5 71.5t-7.5 86v306h68v-294q0 -37 5 -69t19 -56t38.5 -38t62.5 -14q31 0 60 11.5t53 31t42.5 45.5t28.5 55v328h68v-521h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 641,
    d: "M557 548v-548h-62v252h-349v-252h-62v548h62v-239h349v239h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 648,
    d: "M488 48q-34 -24 -75 -38t-88 -14q-63 0 -115 23.5t-88.5 62.5t-57 89t-20.5 103q0 54 21.5 104.5t59 88.5t89 61t111.5 23q63 0 114.5 -24t88.5 -63.5t57 -89.5t20 -101q0 -56 -22 -106.5t-60 -88.5l71 -78h-62zM325 53q36 0 67 10.5t57 28.5l-75 83h62l47 -53 q29 32 44 71t15 81q0 43 -16 83t-45 70.5t-68.5 49t-87.5 18.5q-50 0 -90 -19.5t-68.5 -50.5t-44 -71t-15.5 -80q0 -43 16 -83t44.5 -70.5t68.5 -49t89 -18.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0394",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0431",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0410",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0408",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u018F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "three.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0455",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0437",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0434",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0431",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0430",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0410",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0408",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 247
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_l",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_i",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0165",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B0",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0447",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0427",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0424",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0422",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0416",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "one.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "one.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xF0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -126
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\\\\\\\\",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "*",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0414",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "*",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0425",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0422",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0447",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0445",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0422",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0436",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0408",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0405",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\\\\\\\\",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0445",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0422",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0408",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0434",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0425",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0422",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0417",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0408",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0408",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u044A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "?",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0442",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0458",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0434",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0458",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044F",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044D",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0447",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0445",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0436",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0434",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0431",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0430",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0410",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Z.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lnum",
    g2: "seven.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "\xF7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "+",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "zero",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0408",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0410",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0414",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0409,uni041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0394",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0408",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "two",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0416",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0422",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni040E,uni0423",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0425",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0427",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni042A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0402,uni040B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0436",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0437",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0445",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0427",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0442",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0443,uni045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0447",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni044A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0404,uni041E,uni0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0424",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0409,uni041B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0404,uni041E,uni0421",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A9,Omega",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0402,uni040B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni04B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0409,uni041B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0443,uni045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0408",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0410",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0409,uni041B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0408",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0410",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0409,uni041B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni043B,uni0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0422",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni042A",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0402,uni040B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni04B0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0408",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0409,uni041B",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni043B,uni0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0422",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0402,uni040B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0443,uni045E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0445",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "pi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "four",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eight",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "copyright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "registered",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "at",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "at",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quotedbl,quotesingle",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03A9,Omega",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "uni0394",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0409,uni041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0443,uni045E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0404,uni041E,uni0421",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0409,uni041B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0409,uni041B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni040E,uni0423",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0402,uni040B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0404,uni041E,uni0421",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni042D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0405",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "slash",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "guillemotleft,guilsinglleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0442",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0443,uni045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni04B1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0431",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "slash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0408",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0410",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0409,uni041B",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0434",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni040E,uni0423",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0417",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0409,uni041B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni043B,uni0459",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotright,guilsinglright",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni043B,uni0459",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0443,uni045E",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0404,uni041E,uni0421",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "slash",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotright,guilsinglright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0408",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0410",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0430",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0409,uni041B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni043B,uni0459",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044D",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0455",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0436",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0445",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0404,uni041E,uni0421",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0431",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "colon,semicolon",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0405",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "exclam",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni040E,uni0423",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0402,uni040B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0404,uni041E,uni0421",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni040E,uni0423",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0442",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni044A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "asterisk",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "question",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "backslash",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0443,uni045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "slash",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotleft,guilsinglleft",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotright,guilsinglright",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0408",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0410",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0430",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0409,uni041B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0434",
    k: 183
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni043B,uni0459",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 189
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044D",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044F",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0455",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0436",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0437",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0442",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0443,uni045E",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0445",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0447",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0404,uni041E,uni0421",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0424",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0431",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042F",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "colon,semicolon",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0404,uni041E,uni0421",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0456,uni0457,uni0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0409,uni041B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni043B,uni0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0402,uni040B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotright,guilsinglright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0434",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni043B,uni0459",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni044F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0434",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0442",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni0443,uni045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0438,uni0439,uni043B,uni043C,uni043D,uni043F,uni0447,uni0448,uni044B,uni044F,uni045D,uni045F",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "backslash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0434",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni043B,uni0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0436",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0442",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0445",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "slash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni043B,uni0459",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quotedbl,quotesingle",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteright,quotedblright",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0442",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0443,uni045E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni04B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteleft,quotedblleft",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "asterisk",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "question",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "backslash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0443,uni045E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayRegular);
export default __webpack_public_path__ + "static/media/Raleway-Regular.9581ef537e6094869b8c67061fcbb583.svg";
export { ForwardRef as ReactComponent };